<template>
  <div class="flex-1 p-4 text-sm">
    <div class="text-transparent text-xs">{{reload}}</div>
    <div class="col-span-full flex justify-end gap-3">
      <!-- 宛名の印刷と退職届の PDF は出力画面（AKBS関連「出力」。サブタスク「●●送付」から開く）で出す。ここの「宛名印刷」「退職届PDF」ボタンは外した（ユーザー決定） -->

      <!-- 人事部、管理者のみ -->
      <div class="ml-auto" v-if="auth">
        <div v-tooltip="'人事部、管理者のみ設定可能'" class="w-auto py-0 text-sm text-right mr-3 text-indigo-800 hover:text-indigo-500 cursor-pointer" @click="openChatRoomId=true">Chatwork通知設定</div>
      </div>
    </div>

    <div class="mt-3" style="min-width: 500px;">

      <div v-if="!requestPost._id" class="text-xs font-bold text-red-700 mb-3 sm:col-span-full">
        清掃員の新規入社は面接タスク完了時に自動で作られます
        <span class="text-blue-700 cursor-pointer pl-5 text-xs font-bold underline" @click="newEnterForCD">手動で完了前に作る場合はこちらをクリック</span>
      </div>

      <div class="five-selection">
        <SelectionButton2
          name="employmentClass"
          caption="種別"
          v-model="requestPost.employmentClass"
          :item="classSelections"
          :multiSelect="false"
          :required="true"
          :error="!requireValidateArr('employmentClass', '種別').result"
          :errorMessage="requireValidateArr('employmentClass', '種別').message"
          :disabled="referenceMode2||!requestPost.notNewEnter"
          @change="changeEmploymentClass($event)"
        />
      </div>

      <div v-if="type == 'その他変更'" class="font-bold text-indigo-700 mt-5">◆「その他変更」は稼働管理・給与に影響しない項目のみです◆</div>


      <!-- 契約変更の場合 -->
      <div class="mt-3" v-if="isShow('変更もしくは終了')">
        <div class="text-xs mb-1 font-bold text-gray-700">変更もしくは終了
          <span class="text-red-500"> * </span>
        </div>
        <!-- 改修注意！増えたら、タイトルも変わるように！ -->
        <div class="flex text-sm border border-blue-800 rounded text-center cursor-pointer w-fit" :class="referenceMode2?'cursor-not-allowed':''">
          <div @click="clickModifyType(1, false)" :class="requestPost.modifyType==1 && !requestPost.changeOnlyPrice?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-l w-115px py-2 px-3 border-r">契約内容変更</div>
          <div @click="clickModifyType(1, true)" :class="requestPost.modifyType==1 && requestPost.changeOnlyPrice?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="w-115px py-2 px-3 border-r">金額のみ変更</div>
          <div @click="clickModifyType(2, false)" :class="requestPost.modifyType==2?'bg-blue-800 text-white font-bold':'text-gray-600 bg-white'" class="rounded-r w-115px py-2 px-3">作業終了</div>
        </div>
      </div>

      <!-- 退職日 -->
      <WmsDateInput
        v-if="isShow('退職日')"
        name="employmentRetirementDate"
        caption="退職日"
        v-model="requestPost.employmentRetirementDate"
        :clearable="true"
        :required="isRequired('退職日')"
        :error="!requireValidateStr('employmentRetirementDate', '退職日').result"
        :errorMessage="requireValidateStr('employmentRetirementDate', '退職日').message"
        @change="setLimitDate()"
        :disabled="referenceMode2"
        class="mt-3"
      />

      <div v-if="type=='契約変更'">
        <div v-if="requestPost.modifyType==1" class=" mt-3">
          <label class="flex items-center cursor-pointer gap-2 h-14">
            <input
              type="checkbox"
              v-model="requestPost.overwrite"
              :disabled="referenceMode2"
            />
            <div :class="requestPost.overwrite?'text-blue-700 font-bold':'text-gray-600'">上書きする（登録間違い等で以前のデータを上書きしたい）</div>
          </label>
          <WmsDateInput
            v-if="!requestPost.overwrite"
            name="employmentRetirementDate"
            caption="変更適用開始日（上書きではない）"
            v-model="requestPost.employmentRetirementDate"
            :class="requestPost.employmentRetirementDate?'yellow':''"
            :clearable="true"
            :required="true"
            :error="!requestPost.employmentRetirementDate"
            @change="setLimitDate()"
            :disabled="referenceMode2"
            class="mt-3"
          />
        </div>

        <WmsDateInput
          v-else
          name="employmentRetirementDate"
          caption="作業終了日"
          v-model="requestPost.employmentRetirementDate"
          :class="requestPost.employmentRetirementDate?'yellow':''"
          :clearable="true"
          :required="true"
          :error="!requestPost.employmentRetirementDate"
          @change="setLimitDate()"
          :disabled="referenceMode2"
          class="mt-3"
        />
      </div>

      <NumericTextInput2
        name="employmentStaffNumber"
        :caption="type=='再入社'?'新しい社員番号':'社員番号'"
        v-model="requestPost.employmentStaffNumber"
        :format="false"
        :disabled="['新規入社', '再入社'].includes(type)?referenceMode2:true"
        class="mt-3"
      />

      <div v-if="type=='再入社'" class="font-bold text-gray-500 mt-1 ml-3 mb-8">
        ◆ 以前の社員番号：{{ requestPost.beforeStaffCd }}
      </div>

      <!-- 氏名 -->
      <div class="mt-3">
        <!-- 手入力 -->
        <WmsTextInput
          v-if="requestPost.employmentClass&&['新規入社'].includes(type)"
          name="employmentName"
          caption="氏名"
          v-model="requestPost.employmentName"
          :disabled="referenceMode2"
          :required="isRequired('氏名')"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @change="setTitle()"
        />
        <!-- 選択 -->
        <WmsSuggestInput
          v-else
          name="employmentName"
          :caption="type=='再入社'?'氏名（ドロップダウンは退職者です。選択すると以前の住所などが表示されます。）':'氏名'"
          :required="isRequired('氏名')"
          :selectionItems="employmentNameList"
          displayField="nameStaff"
          v-model="requestPost.employmentName"
          :disabled="referenceMode2"
          :error="!requireValidateStr('employmentName', '氏名').result"
          :errorMessage="requireValidateStr('employmentName', '氏名').message"
          @selected="staffSelected($event)"
          @blur="staffChanged()"
        >
        </WmsSuggestInput>

        <!-- 生年月日・年齢（雇用支持から取得した生年月日） -->
        <div v-if="requestPost.birthday" class="font-bold text-gray-500 mt-1 ml-3">
          ◆ 生年月日：{{ requestPost.birthday }}
          <span class="pl-5">現在 {{ ageCalculation(requestPost.birthday) }} 歳</span>
        </div>
      </div>

      <!-- *******************契約変更・退職の場合******************* -->
      <div v-if="requestPost.contractList && requestPost.contractList.length && ['契約変更', '退職'].includes(type)">
        <InputGroupLabel
          :caption="type == '契約変更'? (requestPost.modifyType==1?'変更対象の契約に✓を入れてください':'作業終了する契約に✓を入れてください') :requestPost.employmentName+' さんの契約'"
          class="mt-10"
        />

        <div v-for="(row, i) in requestPost.contractList" :key="'cl'+i" class="my-4">
          <label class="flex items-center cursor-pointer gap-2">
            <input
              v-if="type == '契約変更'"
              type="checkbox"
              v-model="row.isChecked"
              :disabled="referenceMode2"
              @change="checkWorkEnd(row)"
            >
            <span :class="row.isChecked||type=='退職'?'text-blue-800 font-bold':'text-gray-700'"><span v-if="type=='退職'">◆ </span><span v-else>No.{{ i+1 }}</span> {{ row.nameSite }}（契約コード：{{ row.cdContract }}）</span>
            <span v-if="row.nameContentsWork" :class="row.isChecked?'text-blue-800 font-bold':'text-gray-700'">{{ row.nameContentsWork }}</span>
            <!-- <span class="text-xs text-gray-700"> ※物件コード：{{ row.cdSite }}</span> -->
          </label>

          <!-- 勤務情報 -->
          <div class="flex text-gray-500 text-xs ml-5">
            <div v-for="(w, j) in weekList" :key="i+'w'+j">
              <div v-if="row['start'+w.id]" class="border border-gray-300 rounded px-1 py-1 my-2 mx-1">{{ w.name }}：{{ row['start'+w.id] }} ~（{{ row['workingHours'+w.id] }}h）</div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="requestPost.employmentStaffNumber&&['契約変更', '退職'].includes(type)" class="font-bold text-center text-gray-600 mt-5">
        現在、{{ requestPost.employmentName }} さんが契約しているものがありません。
      </div>

      <!-- *******************その他変更の場合******************* -->
      <div v-if="type == 'その他変更'" class="mt-5 mb-3">

        <WmsDateInput
          name="employmentChangedDate"
          caption="変更日"
          v-model="requestPost.employmentChangedDate"
          :clearable="true"
          :required="true"
          :error="!requireValidateStr('employmentChangedDate', '変更日').result"
          :errorMessage="requireValidateStr('employmentChangedDate', '変更日').message"
          :disabled="referenceMode2"
          class="mt-5"
          :class="requestPost.employmentChangedDate?'yellow':''"
        />

        <div class="text-xs font-bold text-gray-600 mt-10 mb-1 pt-3 w-full border-t border-gray-400 border-dashed">変更したい項目を選択してください</div>
        <div class="flex gap-1 flex-wrap">
          <div v-for="(item, i) in otherChangeItems" :key="'oc'+i" @click="clickOtherChange(item)" class="cursor-pointer py-2 text-center rounded text-sm flex-1 border" :class="requestPost.otherChangeItemsKey.includes(item.key)?'bg-indigo-700 text-white font-bold':'bg-white text-gray-600'">
            {{ item.names[0] }}
          </div>
        </div>

        <!-- 氏名の変更の場合 -->
        <WmsTextInput
          v-if="requestPost.otherChangeItemsKey.includes('staffName')"
          name="staffName"
          caption="氏名"
          v-model="requestPost.staffName"
          :disabled="referenceMode2"
          :required="true"
          :error="!requestPost.staffName"
          class="mt-3"
          @change="isOtherChange(requestPost, -1, 'staffName')"
        :class="getBgColor(requestPost, 'staffName')"
        />
      </div>

      <WmsTextInput
        v-if="isShow('フリガナ')"
        name="employmentKana"
        caption="フリガナ"
        v-model="requestPost.employmentKana"
        :disabled="referenceMode2"
        :required="true"
        :error="!requireValidateStr('employmentKana', 'フリガナ').result"
        :errorMessage="requireValidateStr('employmentKana', 'フリガナ').message"
        class="mt-3"
        @change="isOtherChange(requestPost, -1, 'employmentKana')"
        :class="getBgColor(requestPost, 'employmentKana')"
      />

      <div v-if="isShow('生年月日')">
        <WmsDateInput
          name="employmentBirthDay"
          caption="生年月日"
          v-model="requestPost.employmentBirthDay"
          :clearable="true"
          :required="true"
          :error="!requireValidateStr('employmentBirthDay', '生年月日').result"
          :errorMessage="requireValidateStr('employmentBirthDay', '生年月日').message"
          :disabled="referenceMode2"
          class="mt-3"
          @change="isOtherChange(requestPost, -1, 'employmentBirthDay')"
          :class="getBgColor(requestPost, 'employmentBirthDay')"
        />
        <div v-if="requestPost.employmentBirthDay" class="text-blue-800 mt-1 mb-2 mx-3 text-sm">
          和暦： {{ japaneseDate(requestPost.employmentBirthDay) }}
        </div>
      </div>

      <!-- ここにも入社日 -->
      <WmsDateInput
        v-if="isShow('入社日')&&type!='物件追加'"
        name="employmentHireDate"
        caption="入社日"
        v-model="requestPost.employmentHireDate"
        :clearable="true"
        :required="true"
        :error="!requireValidateStr('employmentHireDate', '入社日').result"
        :errorMessage="requireValidateStr('employmentHireDate', '入社日').message"
        @change="setLimitDate()"
        :disabled="referenceMode2"
        class="mt-3"
      />

      <div v-if="isShow('年齢')" class="text-xs font-bold text-gray-600 mt-3 mb-1">現在の年齢</div>
      <div v-if="isShow('年齢')" class="text-sm py-1.5 px-3 w-full rounded cursor-not-allowed border border-gray-300 text-gray-700 bg-gray-200">
        {{ ageCalculation(requestPost.employmentBirthDay) }}
      </div>

      <SelectionButton2
        v-if="isShow('性別')"
        name="employmentSex"
        caption="性別"
        v-model="requestPost.employmentSex"
        :item="sexSelections"
        :multiSelect="false"
        :disabled="referenceMode2"
        :required="true"
        :error="!requireValidateArr('employmentSex', '性別').result"
        :errorMessage="requireValidateArr('employmentSex', '性別').message"
        class="mt-3"
      />

      <div class="mt-3 flex gap-2 items-end" v-if="isShow('郵便番号')">
        <WmsTextInput
          name="employmentPostCode"
          caption="郵便番号"
          placeholder="000-0000"
          v-model="requestPost.employmentPostCode"
          :disabled="referenceMode2"
          :required="true"
          :error="!requireValidateStr('employmentPostCode', '郵便番号').result"
          :errorMessage="requireValidateStr('employmentPostCode', '郵便番号').message"
          @change="isOtherChange(requestPost, -1, 'employmentPostCode')"
          :class="getBgColor(requestPost, 'employmentPostCode')"
        />
        <PrimaryButton v-if="!referenceMode" text="住所検索" class="w-40 bg-green-500" @click="addressSearch(requestPost.employmentPostCode, 'employmentAddress1')"></PrimaryButton>
        <PrimaryButton v-if="!referenceMode" text="住所から取得" class="w-40 bg-green-500" @click="postalCodeSearch(requestPost.employmentAddress1 + requestPost.employmentAddress2, 'employmentPostCode')"></PrimaryButton>
      </div>

      <WmsTextInput
        v-if="isShow('住所１')"
        name="employmentAddress1"
        caption="住所１"
        v-model="requestPost.employmentAddress1"
        :disabled="referenceMode2"
        :required="true"
        :error="!requireValidateStr('employmentAddress1', '住所１').result"
        :errorMessage="requireValidateStr('employmentAddress1', '住所１').message"
        class="mt-3"
        @change="isOtherChange(requestPost, -1, 'employmentAddress1')"
        :class="getBgColor(requestPost, 'employmentAddress1')"
      />

      <WmsTextInput
        v-if="isShow('住所２')"
        name="employmentAddress2"
        caption="住所２"
        v-model="requestPost.employmentAddress2"
        :disabled="referenceMode2"
        class="mt-3"
        @change="isOtherChange(requestPost, -1, 'employmentAddress2')"
        :class="getBgColor(requestPost, 'employmentAddress2')"
      />

      <div class="mt-3" v-if="isShow('固定電話')">
        <div class="text-xs font-bold text-gray-700 mb-1">固定電話</div>
        <input
          type="tel"
          v-model="requestPost.employmentTel"
          :disabled="referenceMode2"
          class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
          :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':'', getBgColor2(requestPost, 'employmentTel')]"
          @keypress="onKeyPressTel"
          @change="isOtherChange(requestPost, -1, 'employmentTel')"
        />
      </div>

      <div class="mt-3" v-if="isShow('携帯電話')">
        <div class="text-xs font-bold text-gray-700 mb-1">
          携帯電話
          <span class="ml-1 text-red-500"> * </span>
          <span v-if="errMobile(requestPost.employmentMobile)" class="text-xs font-bold text-red-500 ml-5">{{ errMobile(requestPost.employmentMobile) }}</span>
        </div>

        <div class="flex gap-2 relative">
          <InputIcon v-if="!requireValidateStr('employmentMobile', '携帯電話').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('employmentMobile', '携帯電話').message" />
          <input
            type="tel"
            name="employmentMobile"
            v-model="requestPost.employmentMobile"
            :disabled="referenceMode2"
            class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
            :class="[referenceMode?'bg-gray-200 cursor-not-allowed text-gray-500':'', getBgColor2(requestPost, 'employmentMobile')]"
            @keypress="onKeyPressTel"
            @change="isOtherChange(requestPost, -1, 'employmentMobile')"
          />
        </div>
      </div>

      <!-- スマイル移行で追加 -->
      <!-- *******************ご家族******************* -->
      <!-- <div class="sm:col-span-full grid grid-cols-10 mt-10">
        <div class="sm:col-span-9">
          <InputGroupLabel
            name="familyTitle"
            caption="ご家族"
          />
        </div>

        <div class="addButton-contents sm:col-span-1" v-if="!referenceMode2">
          <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addFamilyMember">
            <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>
      </div>

      <div v-for="(row, i) in requestPost.familyMembers" :key="'f'+i"  class="mt-2">
        <div class="sm:col-span-full grid grid-cols-10 items-end">
          <div class="sm:col-span-1 pr-1">
            <WmsSuggestInput
              name="relationship"
              caption="関係"
              :selectionItems="familyRelations"
              displayField="text"
              v-model="row.relationship"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'relationship')"
              @change="isChanged(row, 'relationship')"
              />
          </div>

          <div class="sm:col-span-2 pr-1">
            <WmsTextInput
              name="familyName"
              caption="氏名"
              v-model="row.name"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'name')"
              @change="isChanged(row, 'name')"
            />
          </div>

          <div class="sm:col-span-4 pr-1">
            <WmsTextInput
              name="familyAddress"
              caption="住所"
              v-model="row.address"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'address')"
              @change="isChanged(row, 'address')"
            />
          </div>

          <div class="sm:col-span-2 pr-1">
            <label for="familyPhoneNumber" class="block text-xs font-bold text-gray-700">電話番号</label>
            <div class="mt-1 flex relative">
              <input
                type="tel"
                name="familyPhoneNumber"
                v-model="row.phoneNumber"
                class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
                @keypress="onKeyPressTel"
                autocomplete="off"
                :disabled="referenceMode2"
                :class="[referenceMode2?'bg-gray-200 cursor-not-allowed text-gray-500':'', getBgColor(row, 'phoneNumber')]"
                @change="isChanged(row, 'phoneNumber')"
              />
            </div>
          </div>

          <div class="sm:col-span-1" v-if="!referenceMode2">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeFamilyMember(i)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div> -->


      <!-- *******************緊急連絡先******************* -->
      <div class="sm:col-span-full grid grid-cols-10 mt-16" v-if="isShow('緊急連絡先')">
        <div class="sm:col-span-9">
          <InputGroupLabel
            name="categoryTitle"
            caption="緊急連絡先"
          />
        </div>

        <div class="addButton-contents sm:col-span-1" v-if="!referenceMode2">
          <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addEmergency()">
            <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
          </PrimaryButton>
        </div>

        <div v-for="(row, i) in requestPost.emergency" :key="'ema'+i" class="sm:col-span-full">

          <div class="flex w-full gap-1">
            <WmsSuggestInput
              :name="'er'+i"
              caption="関係"
              :selectionItems="familyRelations"
              displayField="text"
              v-model="row.relationship"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'relationship')"
              @change="isOtherChange(row, i, 'emergency', 'relationship')"
            />

            <WmsTextInput
              :name="'en'+i"
              :id="'en'+i"
              caption="氏名"
              v-model="row.name"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'name')"
              @change="isOtherChange(row, i, 'emergency', 'name')"
              class="flex-1"
            />

            <WmsTextInput
              :name="'ek'+i"
              caption="フリガナ"
              v-model="row.kana"
              :disabled="referenceMode2"
              :class="getBgColor(row, 'kana')"
              @change="isOtherChange(row, i, 'emergency', 'kana')"
              class="flex-1"
            />
          </div>

          <label class="block text-xs font-bold text-gray-700 mt-2">
            郵便番号
            <span class="text-xs font-bold text-red-500 ml-5">{{ errPostCode(row.postCode) }}</span>
          </label>
          <div class="flex-1 flex items-end gap-2">
            <input
              type="tel"
              v-model="row.postCode"
              :disabled="referenceMode2"
              class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block sm:text-sm border-gray-300 rounded"
              :class="[referenceMode2?'bg-gray-200 cursor-not-allowed text-gray-500':'', getBgColor2(row, 'postCode')]"
              @keypress="onKeyPressTel"
              @change="isOtherChange(row, i, 'emergency', 'postCode')"
            />
            <PrimaryButton v-if="!referenceMode2" text="住所検索" class="w-32 bg-green-500 mr-2" @click="addressSearch(row.postCode, 'address', i)"></PrimaryButton>
            <PrimaryButton v-if="!referenceMode2" text="住所から取得" class="w-32 bg-green-500" @click="postalCodeSearch(row.address, 'postCode', i)"></PrimaryButton>
          </div>

          <WmsTextInput
            :name="'ea'+i"
            caption="住所"
            v-model="row.address"
            :disabled="referenceMode2"
            class="mt-2"
            :class="getBgColor(row, 'address')"
            @change="isOtherChange(row, i, 'emergency', 'address')"
          />

          <div class="flex mt-2 gap-2">
            <div class="flex-1">
              <div class="text-xs font-bold text-gray-700 mb-1">電話番号</div>
              <input
                type="tel"
                v-model="row.phoneNumber"
                :disabled="referenceMode2"
                class="py-1.5 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded"
                :class="[referenceMode2?'bg-gray-200 cursor-not-allowed text-gray-500':'', getBgColor2(row, 'phoneNumber')]"
                @keypress="onKeyPressTel"
                @change="isOtherChange(row, i, 'emergency', 'phoneNumber')"
              />
            </div>
          </div>

          <!-- 緊急削除ボタン -->
          <div class="w-fit mt-2 ml-auto" v-if="!referenceMode2">
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeEmergency(i)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>
      </div>


      <!-- *******************雇用支持******************* -->
      <InputGroupLabel
        v-if="['新規入社', '再入社'].includes(type)"
        name="siteData"
        caption="雇用指示"
        class="mt-10"
      />

      <!-- ここにも社員番号 -->
      <NumericTextInput2
        v-if="['新規入社', '再入社'].includes(type)"
        name="employmentStaffNumber"
        :caption="type=='再入社'?'新しい社員番号':'社員番号'"
        v-model="requestPost.employmentStaffNumber"
        :format="false"
        :disabled="referenceMode2"
        class="mt-3"
      />

      <WmsDateInput
        v-if="isShow('入社日')"
        name="employmentHireDate"
        caption="入社日"
        v-model="requestPost.employmentHireDate"
        :disabled="referenceMode2"
        :clearable="true"
        :required="isRequired('入社日')"
        :error="!requireValidateStr('employmentHireDate', '入社日').result"
        :errorMessage="requireValidateStr('employmentHireDate', '入社日').message"
        @change="setLimitDate()"
        class="mt-3"
      />

      <WmsDateInput
        v-if="isShow('作業開始日')"
        name="startDateWork"
        caption="作業開始日（物件入社日）"
        v-model="requestPost.startDateWork"
        :min="requestPost.employmentHireDate"
        :disabled="referenceMode2"
        :required="true"
        :error="!requireValidateStr('startDateWork', '作業開始日').result"
        class="mt-3 mb-2 pb-5 w-full border-b border-gray-400 border-dashed"
      />

      <div v-if="isShow('物件名')">
        <WmsSuggestInput
          name="employmentBuildingName"
          caption="物件名"
          :required="isRequired('物件名')"
          :selectionItems="employmentBuildingList"
          displayField="nameSite"
          v-model="requestPost.employmentBuildingName"
          :disabled="referenceMode2"
          :error="!requireValidateStr('employmentBuildingName', '物件名').result"
          :errorMessage="requireValidateStr('employmentBuildingName', '物件名').message"
          @selected="siteSelected($event)"
          @blur="siteChanged()"
          class="mt-3"
        >
          <!-- 検索アイコン -->
          <template #addon-content>
            <Icon
              iconName="Search"
              :clickable="true"
              class="w-4 h-4 mr-0.5"
              @click="openSiteModal()"
            />
          </template>
        </WmsSuggestInput>

        <div class="mt-2 font-bold text-blue-700 text-sm">●物件コード： {{ requestPost.employmentSiteCode }}</div>
        <div v-if="requestPost.employmentSiteCode!='000000000'" class="mt-2 font-bold text-blue-700 text-sm">●物件住所 ： {{ requestPost.employmentSiteAddress }}</div>


        <div v-if="requestPost.contract&&requestPost.contract.length" class="sm:col-span-full my-3">
          <div class="text-xs text-gray-600 font-bold mb-1">
            契約コード<span class="ml-1 text-red-500"> * </span>
          </div>
          <div class="flex gap-1">
            <Icon v-if="!requestPost.contractCode" iconName="ExclamationCircle" class="h-5 w-5 text-red-400 self-center" />
            <select
              class="w-full rounded border-gray-300 text-sm"
              v-model="requestPost.contractCode"
              :disabled="referenceMode2"
              :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':''"
              @change="changeContract()"
            >
              <option v-for="(row, i) in requestPost.contract" :value="row.cdContract" :key="'con'+i">
                {{ row.cdContract }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="mt-3" v-if="isShow('エリア')">
        <div class="text-xs text-gray-600 font-bold relative mb-1">
          エリア <span v-if="requestPost.employmentSiteCode=='000000000'">（代勤専門の場合は、清掃員の住所からエリアを判定）</span> <span v-if="isRequired('エリア')" class="absolute -top-0.5 ml-1 text-red-500"> * </span>
        </div>
        <div class="relative">
          <InputIcon v-if="!requireValidateStr('area', 'エリア').result" iconName="ExclamationCircle" iconColor="red" :message="requireValidateStr('area', 'エリア').message" />
          <select
            class="w-full rounded border-gray-300 text-sm"
            v-model="requestPost.area"
            :disabled="referenceMode2"
            :class="referenceMode?'bg-gray-200 cursor-not-allowed text-gray-800':''"
          >
            <option v-for="(row, index) in areaSelections" :value="row" :key="index">
              {{ row }}
            </option>
          </select>
        </div>
      </div>

      <div class="my-10 rounded bg-green-50 p-2" v-if="isShow('得意先名')&&requestPost.clientLists.length">
        <div class="font-bold ">得意先へ連絡 <span v-if="type=='契約変更'&&requestPost.modifyType==2">（作業終了する物件の得意先のみ表示）</span></div>

        <div v-for="(row, i) in requestPost.clientLists" :key="'cli'+i">

          <div v-if="!(type=='契約変更'&&!row.isChecked)" class="py-3" :class="i>0?'border-t border-gray-400 border-dashed':''">

            <div v-if="row.isChecked&&type=='契約変更'" class="text-red-700 text-xs font-bold mb-2">作業終了に✓が入りました</div>
            <div v-if=row.siteName class="font-bold text-xs text-blue-700 mb-2">◆ No.{{ i+1 }} {{ row.siteName }} <span class="pl-3">{{ row.nameContentsWork }}</span></div>

            <WmsSuggestInput
              name="employmentCustomer"
              caption="得意先名"
              :selectionItems="clientLists"
              :displayField="['clientName', 'clientDepartmentName']"
              v-model="row.clientName"
              :disabled="referenceMode2"
              @selected="clientSelected(row, $event)"
              @change="clientNameChanged(row)"
              class="mt-3"
            >
              <template #addon-content>
                <Icon
                  iconName="Search"
                  :clickable="true"
                  class="w-4 h-4 mr-0.5"
                  @click="openClientModal(i)"
                />
              </template>
            </WmsSuggestInput>

            <WmsTextInput
              name="clientFax"
              caption="FAX番号"
              v-model="row.clientFax"
              :disabled="referenceMode2"
              class="mt-3"
            />

            <div class="flex gap-3 my-2 w-full">
              <PrimaryButton text="メール" size="normal py-1.5" class="w-32" @click="opentMessageForClient(true, row)">
                <Icon slot="before" iconName="Mail" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
              </PrimaryButton>
              <PrimaryButton text="FAX" size="normal py-1.5" class="w-32" @click="opentMessageForClient(false, row)">
                <Icon slot="before" iconName="Printer" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>


      <!-- *******************勤務曜日・時間******************* -->
      <div v-if="isShow('勤務')">

        <div v-if="requestPost.targetSite && requestPost.employmentSiteCode!='000000000'" class="mt-3">

          <InputGroupLabel
            :caption="requestPost.targetSite + ' の情報'"
            class="mt-10"
          />

          <PrimaryButton :text="requestPost.targetSite + ' の情報を再取得'" @click="getDetilSiteInfo(false)" class="my-2">
            <LoadingIcon v-if="loading" slot="before" class="h-4 w-4" />
          </PrimaryButton>

          <div v-if="!loading&&requestPost.siteShort&&Object.keys(requestPost.siteShort).length" class="bg-blue-50 border border-blue-700 p-2 rounded w-fit mb-5 mr-3">
            <div class="text-xs font-bold text-gray-700 mt-1">物件単位の時間差</div>
            <div class="text-xs font-bold text-gray-700">※マイナスは契約時間を満たしていないことを表します。</div>
            <div class="text-xs font-bold text-gray-700">※1週間分を計算しているため勤務形態が毎週以外はご注意ください。</div>
            <div class="text-xs font-bold text-yellow-700 mt-2" v-if="requestPost.siteShort.total==0">過不足なし</div>

            <div class="flex mt-3 mb-1 text-gray-700">
              <div class="mx-2 font-bold" :class="requestPost.siteShort.totalColor">
                <p>TOTAL</p>
                <p class="text-center">{{ requestPost.siteShort.total }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.monColor">
                <p class="text-center">月</p>
                <p class="text-center">{{ requestPost.siteShort.mon }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.tueColor">
                <p class="text-center">火</p>
                <p class="text-center">{{ requestPost.siteShort.tue }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.wedColor">
                <p class="text-center">水</p>
                <p class="text-center">{{ requestPost.siteShort.wed }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.thuColor">
                <p class="text-center">木</p>
                <p class="text-center">{{ requestPost.siteShort.thu }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.friColor">
                <p class="text-center">金</p>
                <p class="text-center">{{ requestPost.siteShort.fri }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.satColor">
                <p class="text-center">土</p>
                <p class="text-center">{{ requestPost.siteShort.sat }}</p>
              </div>
              <div class="mx-2" :class="requestPost.siteShort.sunColor">
                <p class="text-center">日</p>
                <p class="text-center">{{ requestPost.siteShort.sun }}</p>
              </div>
            </div>
            <div class="text-right text-xs mt-1 text-gray-700">{{ requestPost.siteShort.date }} 時点</div>
          </div>

          <div v-if="requestPost.contract&&requestPost.contract.length" class="text-sm flex flex-wrap gap-2 mt-3">
            <div v-for="(row, i) in requestPost.contract" :key="'cont'+i" class="border border-blue-700 rounded p-2">
              <p class="font-bold mb-1">契約コード（{{ row.cdContract }}）<span v-if="!row.type" class="text-xs pl-3 text-red-700">※清掃員がいない欠員物件です</span></p>
              <div class="flex">
                <div class="p-2 bg-green-50 text-gray-700">
                  <p class="font-bold text-xs mb-3">契約時間</p>
                  <p>{{ row.mon || '月：×' }}</p>
                  <p>{{ row.tue || '火：×' }}</p>
                  <p>{{ row.wed || '水：×' }}</p>
                  <p>{{ row.thu || '木：×' }}</p>
                  <p>{{ row.fri || '金：×' }}</p>
                  <p>{{ row.sat || '土：×' }}</p>
                  <p>{{ row.sun || '日：×' }}</p>
                </div>
                <div class="ml-3 p-2 bg-yellow-50 text-gray-700">
                  <p class="font-bold text-xs mb-3">１週間の時間差</p>
                  <p :class="row.mon2Color">{{ '月： ' + Number(row.mon2) }}</p>
                  <p :class="row.tue2Color">{{ '火： ' + Number(row.tue2) }}</p>
                  <p :class="row.wed2Color">{{ '水： ' + Number(row.wed2) }}</p>
                  <p :class="row.thu2Color">{{ '木： ' + Number(row.thu2) }}</p>
                  <p :class="row.fri2Color">{{ '金： ' + Number(row.fri2) }}</p>
                  <p :class="row.sat2Color">{{ '土： ' + Number(row.sat2) }}</p>
                  <p :class="row.sun2Color">{{ '日： ' + Number(row.sun2) }}</p>
                </div>
                <div class="ml-2 text-xs text-blue-700">
                  <div class="mb-2">●作業内容：{{ getNameContentsWork(row.cdContentsWork) }}</div>
                  <div class="mb-2">●祝日勤務：{{ getNameHoliday(row.holiday) }}</div>
                  <div class="mb-2">●全社祝日勤務：{{ getNameYesNo(row.companyHoliday) }}</div>
                  <div>●ゴミ搬出 ：{{ getNameYesNo(row.garbage) }}</div>
                  <div class="text-right text-xs text-gray-700 mt-5 font-bold">{{ row.date }} 時点</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 1週間の実働 -->
        <div class="text-green-700 text-base font-bold mt-3 flex justify-between items-end">
          1週間の実働：{{ totalHours(requestPost.appliedWork) }} 時間
          <!-- 追加ボタン -->
          <div v-if="!referenceMode2" class="addButton-contents">
            <PrimaryButton class="bg-green-500" size="other" :buttonContents="'要'" v-tooltip="'追加'" @click="addAppliedWork()">
              <Icon slot="before" iconName="PlusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>
        </div>

        <div v-for="(aw, i) in requestPost.appliedWork" :key="'AppliedWork' + i" class="mt-3 mb-3 p-2 rounded border-2 border-green-700">
          <div class="mt-1 text-right" v-if="!referenceMode2&&i>0">
            <!-- 勤務曜日・時間 削除ボタン -->
            <PrimaryButton class="bg-red-500" size="other" :buttonContents="'要'" v-tooltip="'削除'" @click="removeAppliedWork(i)">
              <Icon slot="before" iconName="MinusCircle" iconType="outline" :strokeWidth="2" class="h-5 w-5" />
            </PrimaryButton>
          </div>

          <SelectionOneValue
            caption="作業内容"
            v-model="aw.cdContentsWork"
            :list="workSelections"
            :required="true"
            :disabled="referenceMode2"
            class="mt-3"
          ></SelectionOneValue>

          <div class="mt-5 text-xs font-bold text-blue-700 ml-1">
            <div v-if="requestPost.siteWage&&requestPost.siteWage.length" class="mt-1">※契約時給単価は {{ textForWage(requestPost.siteWage) }} のため、交通費含めこれより低い時給にしてください。</div>
            <div v-if="requestPost.siteWage&&requestPost.siteWage.length" class="mt-1">※登録・更新時にチェックします。</div>
            <div v-else-if="requestPost.employmentSiteCode!='000000000'" class="mt-1">※契約時給単価 不明</div>
          </div>

          <NumericTextInput2
            name="basicWage"
            caption="時給"
            v-model="aw.basicWage"
            @change="limitHourlyWageInput(aw)"
            :disabled="referenceMode2"
            :required="true"
            :error="!aw.basicWage"
            class="mt-2 mb-5"
          />

          <!-- *******************交通費******************* -->
          <div v-for="(e, ei) in setKubunTrans" :key="e.key" class="flex gap-4 w-full mt-2">
            <SelectionOneValue
              :caption="e.name"
              v-model="aw[e.key]"
              :list="provisionSelections"
              :required="true"
              :disabled="referenceMode2"
              class="flex-1"
              @change="changeTrans(aw, e.key, setFareTrans[ei].key)"
            ></SelectionOneValue>

            <NumericTextInput2
              :name="setFareTrans[ei].key"
              :caption="setFareTrans[ei].name"
              v-model="aw[setFareTrans[ei].key]"
              :required="true"
              :disabled="referenceMode2"
              class="flex-1"
              :error="!aw[setFareTrans[ei].key]"
            />
          </div>

          <!-- *******************勤務******************* -->
          <div v-if="!referenceMode2" class="mt-5 font-bold text-xs text-red-700">※曜日をクリックでON・OFF可能</div>

          <div class="flex mt-1 gap-1">
            <div v-for="(w, j) in weekList" :key="i+'w'+j"
              class="p-0.5 text-sm text-white font-bold rounded flex flex-col flex-1 text-center multi"
              :class="aw['attendance' + w.id]&&aw['attendance' + w.id].length?'bg-green-800':'bg-gray-300'"
            >
              <div @click="clickWeek(aw, 'attendance' + w.id)" class="cursor-pointer py-0.5 px-2 mb-1 rounded border border-green-800">{{ w.name }}</div>

              <!-- 形態 -->
              <multiselect
                v-if="!referenceMode2"
                v-model="aw['attendance' + w.id]"
                :options="attendanceList"
                :multiple="true"
                :close-on-select="false"
                :show-labels="false"
                :searchable="false"
                :allow-empty="true"
                :hide-selected="true"
                label="name"
                track-by="id"
                class="text-sm"
                placeholder="勤務曜日なら要選択"
                @input="reloadAttendance++"
              ></multiselect>
              <!-- 編集不可の場合 -->
              <div v-else-if="aw['attendance' + w.id]&&aw['attendance' + w.id].length">
                <div v-for="(a, k) in aw['attendance' + w.id]" :key="i+'ww'+j+'a'+k" class="text-white text-sm font-bold bg-green-500 rounded w-20 mx-auto my-1">
                  {{ a.name }}
                </div>
              </div>

              <div v-if="aw['attendance' + w.id]&&aw['attendance' + w.id].length" >
                <!-- 開始 -->
                <div class="mx-auto w-fit">
                  <WmsTimeInput2
                    v-model="aw['start' + w.id]"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode2"
                    @blur="setTime(aw, w.id)"
                    @select="setTime(aw, w.id)"
                  />
                </div>

                <!-- ～ -->
                <div class="font-bold text-white">～</div>

                <!-- 終了 -->
                <div class="mx-auto w-fit -mt-1">
                  <WmsTimeInput2
                    v-model="aw['end' + w.id]"
                    :clearable="true"
                    :hourItems="hourItems"
                    :minuteItems="minuteItems"
                    :disabled="referenceMode2"
                    @blur="setTime(aw, w.id)"
                    @select="setTime(aw, w.id)"
                  />
                </div>

                <!-- 実働時間 -->
                <div class="text-xs text-gray-50 mt-2">実働</div>
                <div class="flex gap-1 self-end justify-center">
                  <input
                    type="number"
                    v-model="aw['workingHours' + w.id]"
                    onwheel="return false;"
                    :disabled="referenceMode2"
                    class="text-sm text-right w-16 border-0 rounded text-gray-700 py-1.5"
                    :class="referenceMode2?'bg-gray-300 cursor-not-allowed':''"
                    @change="getBreakHours(aw, w.id)"
                  />
                  <div class="text-xs text-gray-50 self-center">時間</div>
                </div>

                <div class="text-xs text-gray-50 mt-2">休憩 {{ aw['breakHours' + w.id] || 0 }} 時間</div>

              </div>
              <!-- コピペ -->
              <div class="flex gap-2 pt-3 mt-auto h-fit" v-if="!referenceMode2">
                <PrimaryButton class="bg-indigo-50 text-indigo-600 border-indigo-600 flex-1 px-1" size="xs" text="コピー" v-tooltip="'クリックするとこの曜日の勤務をコピーします'" @click="copy(aw, w.id)"></PrimaryButton>
                <PrimaryButton class="border-indigo-600 flex-1 px-1" size="xs" text="貼付" v-tooltip="'クリックするとコピーした勤務を反映します'" @click="paste(aw, w.id)" @disabled="!copied||!Object.keys(copied).length" :class="(!copied||!Object.keys(copied).length)?'bg-gray-200 text-white':'bg-indigo-100 text-indigo-600'"></PrimaryButton>
              </div>
            </div>
          </div>

          <!-- *******************祝日******************* -->
          <div v-for="(e) in setHoliday" :key="e.key">
            <SelectionOneValue
              :caption="e.name"
              v-model="aw[e.key]"
              :list="e.list"
              :required="true"
              :disabled="referenceMode2"
              class="mt-2"
            ></SelectionOneValue>
          </div>
        </div>
      </div>

      <InputGroupLabel
        v-if="isShow('必要な書類')"
        caption="その他"
        class="mt-10"
      />

      <SelectionButton2
        v-if="isShow('必要な書類')"
        name="employmentMaterial"
        caption="必要な書類"
        v-model="requestPost.employmentMaterial"
        :item="materialSelections"
        :multiSelect="true"
        :disabled="referenceMode"
        :required="isRequired('必要な書類')"
        :error="!requireValidateArr('employmentMaterial', '必要な書類').result"
        :errorMessage="requireValidateArr('employmentMaterial', '必要な書類').message"
        class="mt-3"
      />

      <div class="mt-3" v-if="isShow('履歴書')">
        <div class="text-xs font-bold text-gray-700 mb-1">
          添付資料（履歴書）<span v-if="isRequired('履歴書')" class="ml-1 text-red-500"> * </span>
        </div>
        <WmsAttachment
          name="employmentDocument"
          style="max-width: none!important;"
          :value="requestPost.employmentDocument"
          :disabled="referenceMode"
          @change="attachmentChange('employmentDocument', $event)"
          :errorMessage="requireValidateAttach('employmentDocument', '履歴書').message"
        />
      </div>

      <WmsTextInput
        name="employmentRemarks"
        caption="連絡事項"
        v-model="requestPost.employmentRemarks"
        :multiline="true"
        :rows="3"
        :disabled="referenceMode"
        class="mt-3"
      />
    </div>

    <!-- 契約変更内容 -->
    <div v-if="requestPost.contractList && requestPost.contractList.length && type=='契約変更' && requestPost.modifyType == 1" class="text-sm">

      <InputGroupLabel
        caption="変更内容"
        class="mt-10"
      />

      <!-- 変更内容一覧 -->
      <div v-if="requestPost.changeData&&requestPost.changeData.length">
        <div class="mt-5 text-xs font-bold text-gray-600 mb-0.5">変更内容一覧</div>
        <div class="rounded border border-gray-400 gap-2 bg-yellow-50 flex flex-wrap">
          <div v-for="(key, i) in requestPost.changeData" :key="'ch'+i" class="text-sm text-gray-700 my-2 mx-3">
            <div class="mb-2 font-bold">{{ key.site }}</div>
            <div v-for="(row, j) in key.list" :key="'chrow'+j" class="my-1">
              ● {{ row }}
            </div>
          </div>
        </div>
      </div>

      <!-- 契約内容 -->
      <div v-for="(row, i) in requestPost.contractList" :key="'co'+i" class="">
        <!-- 変更対象のもののみ -->
        <div v-if="row.isChecked" class="font-bold text-green-800 mt-2">No.{{ i+1 }} {{ row.nameSite }}</div>
        <div v-if="row.isChecked" class="border-2 border-green-700 rounded p-2 mb-3">

          <div class="flex text-blue-700 font-bold text-xs mb-3">
            <div class="text-gray-700">作業開始：</div>
            <div>{{ row.startDateWork }}</div>
          </div>

          <div class="flex text-blue-700 font-bold text-xs">
            <div class="text-gray-700 self-center">物件名：</div>
            <div>{{ row.nameSite }}</div>
            <div class="text-gray-700 self-center ml-6">物件コード：</div>
            <div>{{ row.cdSite }}</div>
            <div class="text-gray-700 self-center ml-4">契約：</div>
            <div>{{ row.cdContract }}</div>
          </div>

          <div class="flex text-blue-700 font-bold text-xs">
            <div class="text-gray-700">得意先：</div>
            <div>{{ row.clientName }}</div>
          </div>

          <!-- 金額のみ変更ではない場合 -->
          <div v-if="!requestPost.changeOnlyPrice">
            <!-- 1週間の実働 -->
            <div class="text-green-800 font-bold mt-3">
              1週間の実働（変更後）：{{ totalHours([row]) }} 時間
            </div>

            <!-- 変更前 -->
            <div class="flex mt-3 gap-1">
              <div v-for="(w, j) in weekList" :key="i+'ww'+j"
                class="p-0.5 text-sm text-white font-bold rounded flex flex-col flex-1 text-center multi"
                :class="row['attendance' + w.id]&&row['attendance' + w.id].length?'border-2 border-green-700  bg-green-50':'bg-gray-300'"
              >
                <!-- 曜日名 -->
                <div class="cursor-pointer py-0.5 px-2" :class="row['attendance' + w.id]&&row['attendance' + w.id].length?'text-green-800 bg-green-50':''">{{ w.name }}</div>

                <!-- 勤務日の場合 -->
                <div v-if="row['attendance' + w.id]&&row['attendance' + w.id].length" class="text-gray-600">
                  <!-- 勤務形態 -->
                  <div v-for="(a, k) in row['attendance' + w.id]" :key="i+'ww'+j+'a'+k" class="text-white text-sm font-bold bg-green-500 rounded w-20 mx-auto my-1">
                    {{ a.name }}
                  </div>

                  <!-- 開始 -->
                  <div class="mx-auto w-fit font-bold">
                    {{ row['start' + w.id] }}
                  </div>

                  <!-- ～ -->
                  <div class="font-bold">～</div>

                  <!-- 終了 -->
                  <div class="mx-auto w-fit font-bold">
                    {{ row['end' + w.id] }}
                  </div>

                  <!-- 実働時間 -->
                  <div class="text-sm text-gray-600 mt-2">実働 {{ row['workingHours' + w.id] || 0 }} h</div>
                  <div class="text-xs text-gray-600 mt-2">休憩 {{ row['breakHours' + w.id] || 0 }} h</div>
                </div>
              </div>
            </div>

            <div class="flex justify-between items-end">
              <div class="text-xs text-red-700 flex-1 font-bold">※曜日をクリックでON・OFF可能</div>
              <Icon iconName="ArrowNarrowDown" iconType="outline" :strokeWidth="4" class="h-8 w-6 text-gray-500" />
              <div class="flex-1"></div>
            </div>

            <!-- 変更後 -->
            <div class="flex gap-1">
              <div v-for="(w, j) in weekList" :key="i+'ww'+j"
                class="p-0.5 text-sm text-white font-bold rounded flex flex-col flex-1 text-center multi"
                :class="row['attendance' + w.id + 'Changed']&&row['attendance' + w.id + 'Changed'].length?'border-2 border-green-700 bg-green-50':'bg-gray-300'"
              >
                <!-- 曜日名 -->
                <div @click="clickWeek(row, 'attendance' + w.id + 'Changed', w.id)" class="cursor-pointer py-0.5 px-2 mb-1" :class="row['attendance' + w.id + 'Changed']&&row['attendance' + w.id + 'Changed'].length?'text-green-800 bg-green-50':''">{{ w.name }}</div>

                <!-- 編集可能 -->
                <div v-if="!referenceMode2">
                  <!-- 形態 -->
                  <multiselect
                    v-model="row['attendance' + w.id + 'Changed']"
                    :options="attendanceList"
                    :multiple="true"
                    :close-on-select="false"
                    :show-labels="false"
                    :searchable="false"
                    :allow-empty="true"
                    :hide-selected="true"
                    label="name"
                    track-by="id"
                    class="text-sm multi"
                    :class="row['attendance' + w.id + 'IsChanged']?'yellow-multi':''"
                    placeholder="勤務曜日なら要選択"
                    @input="attendanceChanged(row, w.id)"
                  ></multiselect>

                  <div v-if="row['attendance' + w.id + 'Changed']&&row['attendance' + w.id + 'Changed'].length" class="text-gray-600">
                    <!-- 開始 -->
                    <div class="mx-auto w-fit">
                      <WmsTimeInput2
                        v-model="row['start' + w.id + 'Changed']"
                        :clearable="true"
                        :hourItems="hourItems"
                        :minuteItems="minuteItems"
                        :disabled="referenceMode"
                        @blur="setTime(row, w.id + 'Changed')"
                        @select="setTime(row, w.id + 'Changed')"
                        :class="row['start' + w.id + 'IsChanged']?'yellow':''"
                      />
                    </div>

                    <!-- ～ -->
                    <div class="font-bold">～</div>

                    <!-- 終了 -->
                    <div class="mx-auto -mt-1 w-fit">
                      <WmsTimeInput2
                        v-model="row['end' + w.id + 'Changed']"
                        :clearable="true"
                        :hourItems="hourItems"
                        :minuteItems="minuteItems"
                        :disabled="referenceMode"
                        @blur="setTime(row, w.id + 'Changed')"
                        @select="setTime(row, w.id + 'Changed')"
                        :class="row['end' + w.id + 'IsChanged']?'yellow':''"
                      />
                    </div>

                    <!-- 実働時間 -->
                    <div class="text-xs mt-2">実働</div>
                    <div class="flex gap-1 self-end justify-center">
                      <input
                        type="number"
                        v-model="row['workingHours' + w.id + 'Changed']"
                        onwheel="return false;"
                        class="text-sm text-right w-16 border-gray-300 rounded text-gray-700 py-1.5"
                        @change="getBreakHours(row, w.id + 'Changed')"
                        :class="row['workingHours' + w.id + 'IsChanged']?'yellow-input font-bold':''"
                      />
                      <div class="text-xs self-center">h</div>
                    </div>

                    <div class="text-xs mt-2">休憩 {{ row['breakHours' + w.id + 'Changed'] || 0 }} h</div>

                  </div>
                  <div v-else-if="row['attendance' + w.id + 'IsChanged']" class="px-3 py-2 font-bold text-yellow-600 text-sm">
                    勤務なし
                  </div>
                </div>

                <!-- 編集不可能 -->
                <div v-else class="text-gray-600">
                  <!-- 勤務あり -->
                  <div v-if="row['attendance' + w.id + 'Changed']&&row['attendance' + w.id + 'Changed'].length">
                    <!-- 勤務形態 -->
                    <div v-for="(a, k) in row['attendance' + w.id + 'Changed']" :key="i+'ww'+j+'aa'+k" class="text-white text-sm font-bold rounded w-20 mx-auto my-1" :class="row['attendance' + w.id + 'IsChanged']?'bg-yellow-500':'bg-green-500'">
                      {{ a.name }}
                    </div>

                    <!-- 開始 -->
                    <div class="mx-auto w-fit font-bold p-2 rounded" :class="row['start' + w.id + 'IsChanged']?'yellow-input border border-gray-300':''">
                      {{ row['start' + w.id + 'Changed'] }}
                    </div>

                    <!-- ～ -->
                    <div class="font-bold">～</div>

                    <!-- 終了 -->
                    <div class="mx-auto w-fit font-bold p-2 rounded" :class="row['end' + w.id + 'IsChanged']?'yellow-input border border-gray-300':''">
                      {{ row['end' + w.id + 'Changed'] }}
                    </div>

                    <!-- 実働時間 -->
                    <div class="text-sm mt-2 py-2 rounded" :class="row['workingHours' + w.id + 'IsChanged']?'yellow-input border border-gray-300':''">実働 {{ row['workingHours' + w.id + 'Changed'] || 0 }} h</div>
                    <div class="text-xs mt-2">休憩 {{ row['breakHours' + w.id + 'Changed'] || 0 }} h</div>
                  </div>
                  <div v-else-if="row['attendance' + w.id + 'IsChanged']" class="py-2 font-bold yellow-input rounded border border-gray-300 text-sm w-20">
                    勤務なし
                  </div>
                </div>

                <!-- コピペ -->
                <div v-if="!referenceMode2" class="flex gap-2 pt-3 mt-auto h-fit">
                  <PrimaryButton class="bg-indigo-50 text-indigo-600 border-indigo-600 flex-1 px-1" size="xs" text="コピー" v-tooltip="'クリックするとこの曜日の勤務をコピーします'" @click="copy(row, w.id)"></PrimaryButton>
                  <PrimaryButton class="flex-1 px-1 border-indigo-600" size="xs" text="貼付" v-tooltip="'クリックするとコピーした勤務を反映します'" @click="paste(row, w.id)" @disabled="(!copied||!Object.keys(copied).length)" :class="(!copied||!Object.keys(copied).length)?'bg-gray-200':'bg-indigo-50 text-indigo-600'"></PrimaryButton>
                </div>

              </div>
            </div>

            <!-- ------------------------区分------------------------ -->
            <!-- スマイル移行後に復活 -->
            <!-- <div class="flex gap-2 mt-8">
              <div v-for="(e) in setHoliday" :key="i+e.key" class="flex-1">
                <div class="text-gray-600 font-bold text-xs mb-1">{{ e.name }}</div>
                <select
                  class="rounded border-gray-300 text-sm py-1.5 w-full bg-gray-200 cursor-not-allowed text-gray-800"
                  v-model="row[e.key]"
                  :disabled="true"
                >
                  <option v-for="(p) in e.list" :value="p.id" :key="i+'pp'+p.id">
                    {{ p.name }}
                  </option>
                </select>
              </div>
            </div>

            <Icon iconName="ArrowNarrowDown" iconType="outline" :strokeWidth="4" class="h-6 w-6 text-gray-500 my-1 block mx-auto" />

            <div class="flex gap-2">
              <div v-for="(e) in setHoliday" :key="i+e.key+2" class="flex-1">
                <div class="text-gray-600 font-bold text-xs mb-1">{{ e.name }}</div>
                <select
                  class="rounded border-gray-300 text-sm py-1.5 w-full"
                  v-model="row[e.key + 'Changed']"
                  :disabled="referenceMode2"
                  @change="isChanged(row, e.key + 'Changed')"
                  :class="row[e.key + 'IsChanged']?'yellow':(referenceMode2?'bg-gray-200 cursor-not-allowed text-gray-800':'')"
                >
                  <option v-for="(p) in e.list" :value="p.id" :key="i+'pp'+p.id">
                    {{ p.name }}
                  </option>
                </select>
              </div>
            </div> -->

          </div>
          <!-- ------------------------賃金------------------------ -->
          <div class="font-bold text-gray-600 mt-3 pt-3 border-t border-gray-400 border-dashed">

            <!-- <div v-if="row.siteWage" class="sm:col-span-full mt-1 mb-2 text-sm font-bold text-blue-700 ml-1">
              <div class="mt-1">※契約時給単価は {{ row.siteWage }} 円のため、交通費含めこれより低い時給にしてください。</div>
              <div class="mt-1">※登録・更新時にチェックします。</div>
            </div> -->

            <div class="mb-2">賃金</div>
            <NumericTextInput2
              v-model="row.basicWage"
              :disabled="true"
            />

            <Icon iconName="ArrowNarrowDown" iconType="outline" :strokeWidth="4" class="h-6 w-6 text-gray-500 my-1 block mx-auto" />

            <NumericTextInput2
              v-model="row.basicWageChanged"
              :required="true"
              :error="!row.basicWageChanged"
              :disabled="referenceMode2"
              @change="isChanged(row, 'basicWageChanged')"
              :class="row.basicWageIsChanged?'yellow':''"
            />
          </div>

          <!-- ------------------------交通費------------------------ -->
          <div class="text-gray-600 mt-3 pt-3 border-t border-gray-400 border-dashed">
            <div class="font-bold mb-2">交通費</div>

            <div class="flex gap-4 w-full">
              <div v-for="(e, ei) in setKubunTrans" :key="i+e.key+ei" class="flex-1">
                <div class="text-gray-600 font-bold text-xs mb-1">{{ e.name }}</div>
                <select
                  class="rounded border-gray-300 text-sm py-1.5 w-full bg-gray-200 cursor-not-allowed text-gray-800"
                  v-model="row[e.key]"
                  :disabled="true"
                >
                  <option v-for="(p) in provisionSelections" :value="p.id" :key="i+'p'+p.id">
                    {{ p.name }}
                  </option>
                </select>

                <NumericTextInput2
                  :name="setFareTrans[ei].key"
                  :caption="setFareTrans[ei].name"
                  v-model="row[setFareTrans[ei].key]"
                  :disabled="true"
                  class="mt-1"
                />
              </div>
            </div>

            <Icon iconName="ArrowNarrowDown" iconType="outline" :strokeWidth="4" class="h-6 w-6 text-gray-500 my-1 block mx-auto" />

            <!-- 変更後の交通費 -->
            <div class="flex gap-4 w-full">
              <div v-for="(e, ei) in setKubunTrans" :key="i+e.key+ei+'02'" class="flex-1">
                <div class="text-gray-600 font-bold text-xs mb-1">{{ e.name }}<span class="ml-1 text-red-500"> * </span></div>
                <select
                  class="rounded border-gray-300 text-sm py-1.5 w-full"
                  v-model="row[e.key + 'Changed']"
                  :disabled="referenceMode2"
                  @change="changeTrans(row, e.key + 'Changed', setFareTrans[ei].key + 'Changed')"
                  :class="row[e.key + 'IsChanged']?'yellow':(referenceMode2?'bg-gray-200 cursor-not-allowed text-gray-800':'')"
                >
                  <option v-for="(p) in provisionSelections" :value="p.id" :key="i+'p'+p.id">
                    {{ p.name }}
                  </option>
                </select>

                <NumericTextInput2
                  :name="setFareTrans[ei].key + 'Changed'"
                  :caption="setFareTrans[ei].name"
                  v-model="row[setFareTrans[ei].key + 'Changed']"
                  :required="true"
                  :disabled="referenceMode2"
                  :error="!row[setFareTrans[ei].key + 'Changed'] && row[setFareTrans[ei].key + 'Changed'] !== 0"
                  class="mt-1"
                  @change="isChanged(row, setFareTrans[ei].key + 'Changed')"
                  :class="row[setFareTrans[ei].key + 'IsChanged']?'yellow':''"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 物件選択モーダル -->
    <SiteSelectorModal
      v-model="siteModal"
      :open="siteModal"
      @modalSiteSelected="siteSelected"
    />

    <!-- 得意先検索モーダル -->
    <ClientSelectorModal
      v-model="clientModal"
      :open="clientModal"
      :index="modalData"
      @modalClientSelected="modalClientSelected"
    />

    <!-- 得意先へ連絡モーダル -->
    <MessageForClientModal
      v-model="messageForClient"
      :open="messageForClient"
      :isMail="isMail"
      :clientFax="requestPost.clientFax"
      :clientName="requestPost.clientName"
      :client="client"
      :messageForClientInfo="messageForClientInfo"
      :requestPost="requestPost"
      @close="messageForClient=false"
    />

    <!-- 退社専用Chatwork設定 -->
    <InterviewsChatRoomIdModal
      v-model="openChatRoomId"
      :open="openChatRoomId"
      :type="2"
      @close="openChatRoomId=false"
    />
  </div>
</template>

<script>
  import * as utils from '@libs/utils'
  import * as utilsAKBS from '@libs/utilsAKBS'
  import * as dialogs from '@libs/dialogs'
  import * as helper from '@libs/helper'
  import * as constants from '@libs/constants'
  import * as constantsAKBS from '@libs/constantsAKBS'
  import * as backend from '@libs/backend'
  import moment from 'moment'
  import Icon from '@components/Icon.vue'
  import InputIcon from '@components/InputIcon.vue'
  import PrimaryButton from '@components/PrimaryButton.vue'
  import WmsDateInput from '@wmscomponents/WmsDateInput.vue'
  import WmsTextInput from '@wmscomponents/WmsTextInput.vue'
  import WmsTimeInput2 from '@wmscomponents/WmsTimeInput2.vue'
  import NumericTextInput2 from '@components/NumericTextInput2.vue'
  import SelectionButton2 from '@components/SelectionButton2.vue'
  import SelectionOneValue from '@components/SelectionOneValue.vue'
  import WmsAttachment from '@wmscomponents/WmsAttachment.vue'
  import InputGroupLabel from '../components/InputGroupLabel.vue'
  import WmsSuggestInput from '@wmscomponents/WmsSuggestInput.vue'
  import SiteSelectorModal from '../components/SiteSelectorModal.vue'
  import ClientSelectorModal from '../components/ClientSelectorModal.vue'
  import MessageForClientModal from '../components/MessageForClientModal.vue'
  import InterviewsChatRoomIdModal from '../components/InterviewsChatRoomIdModal.vue'
  import Multiselect from 'vue-multiselect'
  import LoadingIcon from '@assets/loading-circle.svg'

  const SEX_SELECTIONS = [
    {
      value: '男性',
      text: '男性'
    },
    {
      value: '女性',
      text: '女性'
    }
  ]

  const CLASS_SELECTIONS = [
    {
      value: '物件追加',
      text: '物件追加'
    },
    {
      value: '契約変更',
      text: '契約変更'
    },
    {
      value: '退職',
      text: '退職'
    },
    {
      value: 'その他変更',
      text: 'その他変更'
    },
    {
      value: '再入社',
      text: '再入社'
    }
  ]

  const CLOSINGDATE_SELECTIONS = [
    {
      id: 20,
      name: '20日'
    },
    {
      id: 30,
      name: '30日'
    }
  ]

  // 新規入社 必須項目
  const ENTER = ['入社日', '作業開始日', '氏名', 'フリガナ', '生年月日', '年齢', '性別', '郵便番号', '住所１', '携帯電話', '物件名', 'エリア', '得意先名', '作業内容', '時給', '交通費', '電車 区分', '電車 交通費', 'バス 区分', 'バス 交通費', '駐輪 区分', '駐輪 交通費', '勤務', '勤務時間', '祝日区分', '全社祝日勤務', 'ゴミ搬出', '必要な書類', '履歴書']
  // 新規入社 表示のみ
  const ENTER_NOT_REQUIRE = ['住所２', '固定電話', '緊急連絡先']

  // 再入社 必須項目
  const AGAIN = ['入社日', '作業開始日', '氏名', 'フリガナ', '生年月日', '年齢', '性別', '郵便番号', '住所１', '携帯電話', '物件名', 'エリア', '得意先名', '作業内容', '時給', '交通費', '電車 区分', '電車 交通費', 'バス 区分', 'バス 交通費', '駐輪 区分', '駐輪 交通費', '勤務', '勤務時間', '全社祝日勤務', '祝日区分', 'ゴミ搬出', '必要な書類']
  // 再入社 必須ではないが表示する
  const AGAIN_NOT_REQUIRE = ['住所２', '固定電話', '緊急連絡先']

  // 物件追加 必須項目
  const ADD = ['作業開始日', '氏名', '物件名', 'エリア', '得意先名', '作業内容', '時給', '交通費', '電車 区分', '電車 交通費', 'バス 区分', 'バス 交通費', '駐輪 区分', '駐輪 交通費', '勤務', '勤務時間', '全社祝日勤務', '祝日区分', 'ゴミ搬出', '必要な書類']

  // 契約変更 必須項目
  const RETIRE1 = ['変更もしくは終了', '氏名']

  // 退職 必須項目
  const RETIRE2 = ['退職日', '氏名']
  // 退職 必須ではないが表示する
  const RETIRE2_NOT_REQUIRE = ['得意先名']

  // その他変更 必須
  const OTHER = ['氏名', '変更日']

  export default {
    components: {
      Icon,
      InputIcon,
      PrimaryButton,
      WmsDateInput,
      WmsTextInput,
      WmsTimeInput2,
      NumericTextInput2,
      InputGroupLabel,
      SelectionButton2,
      SelectionOneValue,
      WmsAttachment,
      WmsSuggestInput,
      SiteSelectorModal,
      ClientSelectorModal,
      MessageForClientModal,
      InterviewsChatRoomIdModal,
      Multiselect,
      LoadingIcon
    },

    props: {
      requestPost: {
        type: Object,
        default: () => {}
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isTaskRequestMode: {
        type: Boolean,
        default: false
      },
      referenceMode: {
        type: Boolean,
        default: false
      },
      referenceMode2: {
        type: Boolean,
        default: false
      },
      clientLists: {
        type: Array
      },
      departmentLists: {
        type: Array
      }
    },

    data() {
      return {
        sexSelections: SEX_SELECTIONS,
        familyRelations: constants.FAMILIY_RELATIONS,
        areaSelections: constantsAKBS.AREA_SELECTIONS,
        provisionSelections: constantsAKBS.PROVISION_SELECTIONS,
        provisionSelections2: constants.PROVISION_SELECTIONS2,
        workSelections: constantsAKBS.WORK_SELECTIONS,
        yesNo: constants.YES_NO_SELECTIONS,
        closingDate: CLOSINGDATE_SELECTIONS,
        daysSelection: constants.DAYS_SELECTIONS,
        materialSelections: constants.MATERIAL_SELECTIONS,
        hourItems: constants.HOURS,
        minuteItems: constants.MINUTES,
        weeklyHolidayItems: constants.WEEKLY_HOLIDAYS,
        attendanceTypes: constants.ATTENDANCE_TYPES,
        wageTypes: constants.WAGE_SELECTIONS2,
        domainList: constants.DOMAIN_SELECTIONS,

        reload: 0,
        reloadAttendance: 0,
        loading: false,
        // 清掃員リスト
        employmentNameList: [],
        // 物件リスト
        employmentBuildingList: [],
        // 物件検索モーダル
        siteModal: false,
        // 得意先検索モーダル
        clientModal: false,
        // モーダルに渡すデータ
        modalData: null,
        // 得意先へメール送信・FAXモーダル
        messageForClient: false,
        messageForClientInfo: null,
        // 得意先へメール送信
        isMail: false,
        // 得意先情報
        client: {},
        // Chatwork設定モーダルopen
        openChatRoomId: false,
        // 曜日リスト
        weekList: constantsAKBS.WEEK_LIST,
        // 勤務形態リスト
        attendanceList: utils.clone(constantsAKBS.ATTENDANCE),
        // コピーした値
        copied: {},
        // 清掃員リストの種別
        staffListType: '',

        // その他変更対象項目
        otherChangeItems: [
          { key: 'staffName', names: ['清掃員名'], keys: [] },
          { key: 'employmentKana', names: ['フリガナ'], keys: [] },
          { key: 'employmentBirthDay', names: ['生年月日'], keys: [] },
          { key: 'employmentPostCode', names: ['住所', '郵便番号', '住所１', '住所２'], keys: ['employmentAddress1', 'employmentAddress2'] },
          { key: 'employmentTel', names: ['固定電話'], keys: [] },
          { key: 'employmentMobile', names: ['携帯電話'], keys: [] },
          { key: 'emergency', names: ['緊急連絡先'], keys: [] },
        ],
        // セット項目
        setHoliday: [
          { key: 'cdKubunHoliday', name: '祝日区分', list: constantsAKBS.HOLIDAYTYPE_SELECTIONS },
          { key: 'hasExportingCompanysHoliday', name: '全社祝日勤務', list: constantsAKBS.YES_NO_CODE },
          { key: 'hasCarryingoutGarbage', name: 'ゴミ搬出', list: constantsAKBS.YES_NO_CODE },
        ],
        setKubunTrans: [
          { key: 'kubunTrain', name: '電車 区分' },
          { key: 'kubunBus', name: 'バス 区分' },
          { key: 'kubunBicycleParking', name: '駐輪 区分' },
        ],
        setFareTrans: [
          { key: 'fareTrain', name: '電車 交通費' },
          { key: 'fareBus', name: 'バス 交通費' },
          { key: 'fareBicycleParking', name: '駐輪 交通費' },
        ]
      }
    },

    computed: {
      /**
       * Chatwork設定できる人
       * 人事もしくは管理者権限
       */
      auth() {
        // 人事部所属
        const dep = this.$store.getters.dualPosition
        if (dep && dep.length) {
          // 人事部か確認
          const isDep = dep.find((d) => {
            return (d.departmentName.indexOf('人事') > -1)
          })
          if (isDep && isDep.departmentName) {
            return true
          }
        }
        // 管理者権限の場合
        let auth2 = this.$store.getters.auth
        if (auth2 && auth2.adminAuth) {
          return true
        }
        return false
      },

      /**
       * 種別の選択項目
       */
      classSelections() {
        let res = utils.clone(CLASS_SELECTIONS)
        if (!this.requestPost.notNewEnter)  res =  [
          {
            value: '新規入社',
            text: '新規入社'
          }
        ]
        return res
      },

      /**
       * 種別
       */
      type() {
        if (this.requestPost.employmentClass[0]) {
          return this.requestPost.employmentClass[0]
        }
        return ''
      },

      /**
       * 誕生日を和暦に変換
       */
      japaneseDate() {
        return (val)=> {
          if (val) {
            return utils.japaneseDate(val)
          } else {
            return ''
          }
        }
      },

      /**
       * 部署選択肢
       */
      departmentItems() {
        if (this.departmentLists && this.departmentLists.length) {
          return this.departmentLists.map((d) => {
            return { value: d.departmentId, text: d.name }
          })
        }
        return [{ value: '', text: '' }]
      },

      /**
       * 必須項目入力チェック（文字列）
       */
      requireValidateStr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] && this.requestPost[item] !== 0) {

              if (name == '変更適用開始日' && this.requestPost.modifyType == 2) {
                name = '作業終了日'
              }

              return {
                result: false,
                message: `${name}は必須項目です。${name}を入力してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（配列）
       */
      requireValidateArr() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || !this.requestPost[item].length) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を選択してください。`
              }
            }
          }

          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 必須項目入力チェック（添付ファイル）
       */
      requireValidateAttach() {
        return (item, name)=> {
          if (this.isRequired(name)) {
            if (!this.requestPost[item] || (!this.requestPost[item].content && !this.requestPost[item].url)) {
              return {
                result: false,
                message: `${name}は必須項目です。${name}を添付してください。`
              }
            }
          }
          return {
            result: true,
            message: ''
          }
        }
      },

      /**
       * 表示するか否か
       */
      isShow() {
        return (name) => {
          // 種別
          const ec = this.requestPost.employmentClass
          // 新規入社
          const enter = ENTER.concat(ENTER_NOT_REQUIRE)
          // 「再入社」の場合、表示する項目
          const again = AGAIN.concat(AGAIN_NOT_REQUIRE)
          // 「退職」の場合、表示する項目
          const retired = RETIRE2.concat(RETIRE2_NOT_REQUIRE)
          // その他変更
          const other = this.requestPost.otherChangeItemsName

          if (ec && ec.length) {
            const e = ec[0]
            if (e == '新規入社') {
              if (enter.includes(name)) {
                return true
              }
            } else if (e == '再入社') {
              if (again.includes(name)) {
                return true
              }
            } else if (e == '退職') {
              if (retired.includes(name)) {
                return true
              }
            } else if (e == 'その他変更') {
              return  other.some(item => (item == name))

            // その他は、必須項目になっているもののみ表示
            } else {
              return this.isRequired(name)
            }
          }
          return false
        }
      },

      /**
       * 種別によって必須が変わる
       * @param name 項目名
       */
      isRequired() {
        return (name) => {
          // 種別はいつでも必須
          if (name == '種別') {
            return true
          }
          // 種別
          const ec = this.requestPost.employmentClass
          // 新規入社
          const enter = ENTER
          // 再入社
          const again = AGAIN
          // 物件追加
          const add = ADD
          // 契約変更
          const retire1 = RETIRE1
          // 退職
          const retire2 = RETIRE2
          // その他変更
          const other = OTHER.concat(this.requestPost.otherChangeItemsName)

          if (ec && ec.length) {
            const e = ec[0]
            if (e == '新規入社') {
              if (enter.includes(name)) {
                return true
              }
            } else if (e == '再入社') {
              if (again.includes(name)) {
                return true
              }
            } else if (e == '物件追加') {
              if (add.includes(name)) {
                return true
              }
            } else if (e == '契約変更') {
              if (retire1.includes(name)) {
                return true
              } else if (name == '得意先名') {
                if (this.requestPost.modifyType == 2) {
                  return true
                }
              } else if (name == '変更適用開始日') {
                // 内容変更で上書き以外の場合
                if (!(this.requestPost.modifyType == 1 && this.requestPost.overwrite)) {
                  return true
                }
              }
            } else if (e == '退職') {
              if (retire2.includes(name)) {
                return true
              }
            } else if (e == 'その他変更') {
              if (other.includes(name)) {
                return true
              }
            }
          }
          return false
        }
      },

      /**
       * 郵便番号入力形式確認
       */
      errPostCode() {
        return (post)=> {
          if (post) {
            const pattern = /^[0-9]{3}-[0-9]{4}$/
            //入力値が正しいか
            if (!pattern.test(post)) {
              return '【3桁-4桁】の形式で入力してください。'
            }
          }
          return ''
        }
      },

      /**
       * 携帯番号入力形式確認
       */
      errMobile() {
        return (num) => {
          if (num) {
            const pattern = /^[0-9]{3}-[0-9]{4}-[0-9]{4}$/
            //入力値が正しいか
            if (!pattern.test(num)) {
              return '【3桁-4桁-4桁】の形式で入力してください。'
            }
          }
          return ''
        }
      },

      /**
       * 背景色取得
       */
      getBgColor() {
        return (row, val) => {
          const tar = val + 'IsChanged'
          if (row[tar]) {
            return 'yellow'
          }
          return ''
        }
      },

      /**
       * 背景色取得
       */
      getBgColor2() {
        return (row, val) => {
          const tar = val + 'IsChanged'
          if (row[tar]) {
            return 'yellow-input'
          }
          return ''
        }
      },

      /**
       * 少数の表示範囲
       */
      getDecimalPlace() {
        return (val) => {
          if (val && val.length) {
            const num = String(val).split('.')
            if (num[1]) {
              return num[1].length
            } else {
              return 0
            }
          }
          return 0
        }
      },

      /**
       * 時給単価をわかりやすく、文字列で表示
       */
      textForWage() {
        return (wage)=> {
          if (wage && wage.length) {
            if (this.requestPost.contractCode) {
              const res = wage.find((w) => {
                return w.cdContract == this.requestPost.contractCode
              })
              if (res) {
                return res.wage + '円'
              }
            }

            let text = ''
            let arr = {}
            for (let i = 0; i < wage.length; i++) {
              const w = wage[i]
              if (!arr[w.wage]) {
                arr[w.wage] = '契約コード' + w.cdContract
              } else {
                arr[w.wage] += '、' + w.cdContract
              }
            }

            if (Object.keys(arr).length == 1) {
              return Object.keys(arr)[0] + '円'
            }

            for (let i = 0; i < Object.keys(arr).length; i++) {
              const a = Object.keys(arr)[i]
              if (text) {
                text += '、'
              }
              text += '(' + arr[a] + ')➡' + a + '円'
            }
            return text
          }
          return ''
        }
      },

      /**
       * 一週間の実働合計
       */
      totalHours() {
        return (list) => {
          this.reloadAttendance
          if (list && list.length) {
            const typeChanged = (this.type == '契約変更')
            return utilsAKBS.getHoursForOneWeek(list, typeChanged)
          }
          return 0
        }
      },

      /**
       * 作業内容取得
       */
      getNameContentsWork() {
        return(val) => {
          if (val) {
            const tar = this.workSelections.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      },

      /**
       * ありなし
       */
      getNameYesNo() {
        return(val) => {
          if (val != null) {
            const tar =  constantsAKBS.YES_NO_CODE.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      },

      /**
       * 祝日勤務名取得
       */
      getNameHoliday() {
        return(val) => {
          if (val != null) {
            const tar = constantsAKBS.HOLIDAYTYPE_SELECTIONS.find((w) => {
              return w.id == val
            })

            if (tar) {
              return tar.name
            }
          } else {
            return '不明'
          }
        }
      },

      /**
       * 生年月日から年齢を取得
       */
      ageCalculation() {
        return(val) => {
          if (val) {
            const birth = moment(val, 'YYYY-MM-DD', true)
            if (!birth.isValid()) return null
            return moment().diff(birth, 'years')
          }
        }
      }
    },

    watch: {
      loading(val) {
        if (val) {
          this.$emit('loadingStart')
        } else {
          this.$emit('loadingEnd')
        }
      }
    },

    async created() {
      // 清掃員リスト取得
      this.getEmploymentNameList()
      // 物件リスト取得
      await this.getAllEmploymentBuildingList()
      // 新規入社で物件情報（契約単価など）がまだ取得されていない場合（面接から雇入れが作られて初めて画面を開くとき）
      if (!this.requestPost.notNewEnter && (!this.requestPost.siteWage || !this.requestPost.siteWage.length)) {
        await this.getDetilSiteInfo(false)
      }
    },

    methods: {
      onKeyPressTel(event) {
        // Allow numbers (charCode 48-57) and dash (charCode 45)
        if ((event.charCode >= 48 && event.charCode <= 57) ||  event.charCode === 45 ) {
          return true;
        } else {
          event.preventDefault(); // Prevent any other character from being entered
        }
      },

      /**
       * 入力チェック
       */
      async validation() {
        // 種別
        const type = this.type
        // 勤務情報
        let arr = []

        if (!['新規入社', '再入社'].includes(type)) {
          if (!this.requestPost.employmentStaffNumber) {
            await dialogs.showErrorDialog('清掃員をドロップダウンから選択しなおしてください', '「社員番号」が取得できていません。ドロップダウンから清掃員を選択してください。')
            return false
          }

          const staffData = this.employmentNameList.find((e) => {
            return this.requestPost.employmentStaffNumber == e.staffDailyCleaning
          })
          if (staffData) {
            if (staffData.nameStaff != this.requestPost.employmentName) {
              await dialogs.showErrorDialog('清掃員をドロップダウンから選択しなおしてください', '「社員番号」と「氏名」が一致しません。データに矛盾が発生するため、清掃員をドロップダウンから選択後は氏名を変更しないようお願いいたします。')
              return false
            }
          }
        }

        // 配列、文字列
        const items = [
          { key: 'employmentClass', name: '種別' }
          ,{ key: 'modifyType', name: '変更もしくは終了' }
          ,{ key: 'employmentHireDate', name: '入社日' }
          ,{ key: 'employmentRetirementDate', name: '退職日' }
          ,{ key: 'employmentRetirementDate', name: '変更適用開始日' }
          ,{ key: 'startDateWork', name: '作業開始日' }
          ,{ key: 'employmentName', name: '氏名' }
          ,{ key: 'employmentKana', name: 'フリガナ' }
          ,{ key: 'employmentBirthDay', name: '生年月日' }
          ,{ key: 'employmentSex', name: '性別' }
          ,{ key: 'employmentPostCode', name: '郵便番号' }
          ,{ key: 'employmentAddress1', name: '住所１' }
          ,{ key: 'employmentMobile', name: '携帯電話' }
          ,{ key: 'employmentBuildingName', name: '物件名' }
          ,{ key: 'employmentChangedDate', name: '変更日' }
          ,{ key: 'area', name: 'エリア' }
          ,{ name: '勤務' }
          ,{ key: 'employmentMaterial', name: '必要な書類' }
        ]

        for (let i = 0; i < items.length; i++) {
          const item = items[i]

          // 雇用指示の勤務情報
          if (item.name == '勤務' && (this.isShow('勤務') || (type == '契約変更' && this.requestPost.modifyType == 1))) {
            const working = { count: 0, hours: 0 }
            const teiki = {}

            if (this.isShow('勤務')) {
              arr = this.requestPost.appliedWork
            } else if (this.requestPost.contractList && this.requestPost.contractList.length) {
              arr = this.requestPost.contractList.filter(row => {
                return row.isChecked
              })
            }

            for (let i = 0; i < arr.length; i++) {
              const row = arr[i]
              let msg = ''

              if (i) {
                msg = (i + 1) + 'つ目の'

                if (type == '契約変更') {
                  msg = `No.${(i + 1)} ${row.nameSite} の`
                }
              }

              // 金額のみ変更ではない場合、勤務情報に不正な値がないか確認
              if (!(type == '契約変更' && this.requestPost.changeOnlyPrice) && !await this.validateWorking(type, row, working, msg)) return false

              // 祝日、交通費に関するチェック
              const requires = [
                { key: 'cdContentsWork', name: '作業内容' },
                { key: 'basicWage', name: '賃金' },
                ...this.setKubunTrans,
                ...this.setFareTrans,
                ...this.setHoliday
              ]

              // 金額変更のみの場合にチェックしない項目キー配列
              const changeOnlyPriceNoCheck = this.setHoliday.map((h) => h.key)
              changeOnlyPriceNoCheck.push('cdContentsWork')

              for (let j = 0; j < requires.length; j++) {
                const req = requires[j]

                // 金額変更のみの場合、作業内容、祝日勤務はチェックしない
                if (type == '契約変更' && this.requestPost.changeOnlyPrice && changeOnlyPriceNoCheck.includes(req.key)) {
                  continue
                }

                let key = req.key
                if (type == '契約変更') {
                  key = req.key + 'Changed'
                }

                if (key.includes('basicWage')) {
                  await this.limitHourlyWageInput(row)
                }

                if (!row[key] && row[key] !== 0) {
                  await dialogs.showErrorDialog(row.nameSite + 'の' + req.name, '未入力です。入力してください。')
                  return false
                }

                if (!await this.comparisonContract(key, req.name, row, type, msg)) return false

                if (!await utilsAKBS.checkTrans(key, req.name, row, msg, teiki, type)) return false
              }
            }

            if (working.count > 0) {
              if (this.requestPost.siteShort) {
                const total = this.totalHours(arr)
                if (Number(this.requestPost.siteShort.total) >= 0) {
                  const log = await dialogs.showConfirmDialog('契約との時間差 確認', `こちらの物件は、現在、不足時間はありませんが、登録してよろしいですか？\n退職予定の清掃員がいる場合は無視してください。`)
                  if (log != 'YES') {
                    return false
                  }
                } else if (total > Number(this.requestPost.siteShort.total) * -1) {
                  const log = await dialogs.showConfirmDialog('契約との時間差 確認', `1週間の契約との過不足時間が${this.requestPost.siteShort.total}時間に対し、${total} 時間を登録しようとしています。よろしいですか？\r\n退職予定の清掃員がいる場合は無視してください。`)
                  if (log != 'YES') {
                    return false
                  }
                }
              }
            }

            for (let i = 0; i < Object.keys(teiki).length; i++) {
              const t = Object.keys(teiki)[i]
              if (teiki[t].length > 1) {
                if (await dialogs.showConfirmDialog('交通費 区分 1ヶ月の確認', teiki[t].join('\n') + '\nですが、よろしいですか？') != 'YES') return false
              }
            }

            if (this.requestPost.siteWage) {

              if (type != '契約変更') {
                if (this.requestPost.contractCode) {
                  let siteWage = 0
                  const sw = this.requestPost.siteWage.find((w) => {
                    return w.cdContract == this.requestPost.contractCode
                  })
                  if (sw) {
                    siteWage = Number(sw.wage)
                  }

                  if (siteWage) {
                    let wage = 0
                    for (let i = 0; i < arr.length; i++) {
                      const row = arr[i]
                      // 交通費（時給換算）+時給
                      wage += utilsAKBS.getHourlyWage(row, null)
                    }
                    wage = Math.floor(wage / arr.length)
                    if (siteWage < wage) {
                      const log = await dialogs.showWarningConfirmDialog('時給・交通費の確認', `契約時給単価${siteWage}円に対し、交通費を含めた時給は${wage}円で、高くなっています。\nよろしいですか？`)
                      if (log != 'YES') return false
                    }
                  }
                }
              }
            }

          } else if (item.key) {
            let res = {}
            // 配列
            if (Array.isArray(this.requestPost[item.key])) {
              res = this.requireValidateArr(item.key, item.name)

            // 文字列
            } else {
              res = this.requireValidateStr(item.key, item.name)
            }

            if (!res.result) {
              await dialogs.showInfoDialog('入力確認', res.message, 'OK')
              return false
            }
          }
        }

        // オブジェクト
        const valObj = [
          { key: 'employmentDocument', name: '履歴書' }
        ]
        for (let i = 0; i < valObj.length; i++) {
          const a = valObj[i]
          let res = {}
          res = this.requireValidateAttach(a.key, a.name)
          if (!res.result) {
            await dialogs.showInfoDialog('入力確認', res.message, 'OK')
            return false
          }
        }

        // その他項目の確認
        if (this.isShow('生年月日')) {
          const age = this.ageCalculation(this.requestPost.employmentBirthDay)
          if (age < 10 || age >= 100) {
            await dialogs.showErrorDialog('生年月日をご確認ください', `年齢が${age}歳 になっています。\r\n生年月日に間違いがないかご確認ください。`)
            return false
          }
        }

        // 携帯電話の形式✓
        if (!await this.checkMobile()) return false

        if (type == '契約変更' && this.requestPost.contractList && this.requestPost.contractList.length) {
          if (!this.requestPost.contractList.some(item => item.isChecked)) {
            let typeName = '変更'
            if (this.requestPost.modifyType == 2) typeName = '作業終了'
            await dialogs.showErrorDialog(typeName + 'の対象となる契約がありません', '「' + typeName + 'の契約に✓をいれてください」のところで1つ以上✓をいれてください。')
            return false
          }
        }

        return true
      },

      /**
       * 勤務チェック
       * @param type 種別
       * @param tar 対象のデータ
       * @param {*} work 勤務ありの日数
       */
      async validateWorking(type, tar, work, msg) {
        let flg = false

        for (let i = 0; i < this.weekList.length; i++) {
          const w = this.weekList[i]
          let key = w.id
          if (type == '契約変更') {
            key += 'Changed'
          }

          // 勤務形態
          const att = tar['attendance' + key]
          // 開始時間
          const start = tar['start' + key]
          // 終了時間
          const end = tar['end' + key]
          // 実働時間
          const hours = tar['workingHours' + key]

          // 勤務形態区分設定あり
          if (att && att.length) {
            // 勤務日あり
            work.count++
            flg = true

            // 矛盾していないか確認
            if (!await utilsAKBS.checkAttendance(att, w.name)) return false
            // 開始時間未入力
            if (!await utilsAKBS.checkNoTimes(start, w.name + '曜日の勤務時間')) return false
            // 終了時間未入力
            if (!await utilsAKBS.checkNoTimes(end, w.name + '曜日の勤務時間')) return false

            // 時間帯、実働の矛盾
            if (start && end) {
              if (!await utilsAKBS.checkTimes(start, w.name)) return false
              if (!await utilsAKBS.checkTimes(end, w.name)) return false
              if (!await utilsAKBS.checkTimes2(start, end, w.name)) return false
              if (!await utilsAKBS.checkBreakTime(start, end, hours, w.name)) return false
            }
          }
        }

        if (!flg) {
          let msg2 = '削除してください。'
          if (type == '契約変更') {
            msg2 = '「作業終了」を選択してください。'
          }
          await dialogs.showErrorDialog(msg + '勤務', '1日も勤務日がありません。\n' + msg + '勤務を入力するか、' + msg2)
          return false
        }
        return true
      },

      /**
       * 契約詳細情報と比較
       * @param item 項目
       * @param name 項目名
       */
      async comparisonContract(item, name, row, type) {
        let holi = 'cdKubunHoliday'
        let com = 'hasExportingCompanysHoliday'
        let gab = 'hasCarryingoutGarbage'

        if (type == '契約変更') {
          holi += 'Changed'
          com = 'Changed'
          gab = 'Changed'
        }

        // 代勤専門ではなく、契約コードがあり、対象項目の場合
        if (row.employmentSiteCode!='000000000' && row.contractCode && [holi, com, gab].includes(item)) {
          if (this.requestPost.contract && this.requestPost.contract.length) {
            const contract = this.requestPost.contract.find((c) => {
              return c.cdContract == this.requestPost.contractCode
            })

            if (!contract || !contract.cdContract) {
              row.contractCode = null
              this.reload++
              await dialogs.showErrorDialog('契約コード未選択', '契約コードを選択してください。')
              return false
            }

            const val = row[item]
            let msg = ''

            switch (item) {
              case holi:
                if (contract.holiday < val) {
                  msg = `契約コード（${contract.cdContract}）の契約は、${name}が${this.getNameHoliday(contract.holiday)} ですが、${this.getNameHoliday(val)}で登録しようとしています。よろしいですか？`
                }
                break;
              case com:
                if (contract.companyHoliday < val) {
                  msg = `契約コード（${contract.cdContract}）の契約は、${name}が${this.getNameYesNo(contract.companyHoliday)} ですが、${this.getNameYesNo(val)}で登録しようとしています。よろしいですか？`
                }
                break;
              case gab:
                if (contract.garbage < val) {
                  msg = `契約コード（${contract.cdContract}）の契約は、${name}が${this.getNameYesNo(contract.garbage)} ですが、${this.getNameYesNo(val)}で登録しようとしています。よろしいですか？`
                }
                break;
            }

            if (msg) {
              const log = await dialogs.showConfirmDialog(name, msg)
              if (log != 'YES') {
                return false
              }
            }
          }
        }
        return true
      },

      /**
       * 携帯電話の形式チェック
       */
      async checkMobile() {
        if (this.isShow('携帯電話')) {
          const err = this.errMobile(this.requestPost.employmentMobile)
          if (err) {
            await dialogs.showErrorDialog('携帯電話', '清掃員の携帯電話番号の形式が不正です。\n' + err)
            return false
          }
        }
        return true
      },

      /**
       * 郵便番号より住所検索
       */
      async addressSearch(post, value, i) {
        var geocoder = new window.google.maps.Geocoder()
        var pattern = /^[0-9]{3}-?[0-9]{4}$/
        let res = ''

        if(post) {
          var postalCode = post
          if (postalCode) {
            //入力値が正しいか
            if (pattern.test(postalCode)) {
              //住所を取得
              await geocoder.geocode ({
                address:postalCode,
                language:"ja",
                region:"jp"
              }, function (results, status) {
                if (status == window.google.maps.GeocoderStatus.OK) {
                  if (results.length > 0){
                    if (results[0].geometry) {
                      if (results[0].address_components[4].long_name == '日本') {
                        res = results[0].address_components[3].long_name +
                        results[0].address_components[2].long_name + results[0].address_components[1].long_name
                      } else {
                        res = results[0].address_components[4].long_name +
                        results[0].address_components[3].long_name + results[0].address_components[2].long_name +
                        results[0].address_components[1].long_name
                      }
                    }
                  }
                } else {
                  if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
                    res = ''
                    alert("郵便番号は見つかりませんでした。")
                  } else {
                    res = ''
                    alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
                  }
                }
              })
            } else {
              alert("入力が3桁-4桁の形式であるか確認してください。")
            }
          }
        } else {
            alert("郵便番号を入力をしてください。")
        }

        // indexがある場合
        if (i >= 0) {
          this.requestPost.emergency[i][value] = res
        } else {
          this.requestPost[value] = res
        }
        this.reload++
      },

      /**
       * 住所より郵便番号検索
       */
      postalCodeSearch(address, tar, i){
        var geocoder = new window.google.maps.Geocoder()
        const self = this
        if (!address) {
          alert("住所を入力してください")
          return
        }
        geocoder.geocode({
          address: address,
          language: "ja",
          region: "jp"
        }, function (results, status) {
          //アラート用フラグ
          var flag = false
          let res = ''
          if (status == window.google.maps.GeocoderStatus.OK) {
            if (results.length > 0) {
              if (results[0].geometry) {
                var result = results[0].address_components
                result.forEach(function(returnData) {
                  returnData.types.forEach(function(getType) {
                    if (getType == 'postal_code') {
                      res = returnData.long_name
                      flag = true
                    }
                  })
                })
              }
            }
            if (flag == false) {
              res = ''
              alert("郵便番号が見つかりませんでした。")
            }
          } else {
            if (status == window.google.maps.GeocoderStatus.ZERO_RESULTS) {
              res = ''
              alert("郵便番号は見つかりませんでした")
            } else {
              res = ''
              alert("システムの管理者にお問い合わせください。ステータスコード：" + status)
            }
          }

          // indexがある場合
          if (i >= 0) {
            self.requestPost.emergency[i][tar] = res
          } else {
            self.requestPost[tar] = res
          }
          self.reload++
        })
      },

      /**
      * 家族追加ボタン
      */
      addFamilyMember() {
        let add = {
          relationship: '',
          name: '',
          address:'',
          phoneNumber: ''
        }
        this.requestPost.familyMembers.push(add)
        this.reload++
      },

      /**
      * 家族削除ボタン
      */
      removeFamilyMember(idx) {
        this.requestPost.familyMembers.splice(idx, 1)
        this.reload++
      },

      /**
       * 緊急連絡追加ボタン
       */
      addEmergency() {
        this.requestPost.emergency.push({})
        this.reload++
      },

      /**
       * 緊急連絡削除ボタン
       */
      removeEmergency(i) {
        this.requestPost.emergency.splice(i, 1)
        if (!this.requestPost.emergency || !this.requestPost.emergency.length) {
          this.addEmergency()
        }
        this.reload++
      },

      /**
       * 添付ファイル
       */
      attachmentChange(targetAttachmentName, attachmentInfo) {

        // 面接から履歴書を引き継いでいたので、変更の際はそれをリセット
        delete this.requestPost[targetAttachmentName + '_file_content']
        delete this.requestPost[targetAttachmentName + '_display_file_name']
        delete this.requestPost[targetAttachmentName + '_file_name']

        if (!this.requestPost[targetAttachmentName]) {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
        if (attachmentInfo) {
          this.requestPost[targetAttachmentName].originalName = attachmentInfo.filename
          this.requestPost[targetAttachmentName].content = attachmentInfo.content
        } else {
          this.requestPost[targetAttachmentName] = helper.createEmptyAttachment()
        }
      },

      /**
       * 賃金の確認
       */
      async limitHourlyWageInput(row) {
        let key = 'basicWage'
        if (this.type == '契約変更') {
          key += 'Changed'
        }
        const err = utils.validateHourlyWage(row[key])
        if (err) {
          await dialogs.showErrorDialog('賃金', err)
          row[key] = ''
          this.reload++
        }
      },

        /**
       * 勤務曜日・時間 追加ボタン
       */
      addAppliedWork() {
        const copy = utils.clone(this.requestPost.appliedWork[0])
        this.requestPost.appliedWork.push(copy)
      },

      /**
       * 勤務曜日・時間 削除ボタン
       */
      removeAppliedWork(idx) {
        this.requestPost.appliedWork.splice(idx, 1)
        if (!this.requestPost.appliedWork || !this.requestPost.appliedWork.length) {
          this.addAppliedWork()
        }
      },

      /**
       * 曜日クリック
       * @param row 対象行
       * @param key クリックした曜日
       */
      clickWeek(row, key, week) {
        if (this.referenceMode2) return

        if (row[key] && row[key].length) {
          row[key] = []
        } else {
          row[key] = [this.attendanceList[0]]
        }

        if (key.includes('Changed')) {
          this.attendanceChanged(row, week)
        }
        this.reloadAttendance++
      },

      /**
       * 実働時間セット
       */
      async setTime(row, key) {
        await utils.wait(200)
        let hours = utils.getHours(row['start' + key], row['end' + key])
        if (hours > 6) {
          hours--
        }
        row['workingHours' + key] = hours
        this.getBreakHours(row, key)

        // 契約変更の場合、変更があったか判定
        this.isChanged(row, 'workingHours' + key)
        this.isChanged(row, 'start' + key)
        this.isChanged(row, 'end' + key)

        this.reloadAttendance++
      },

      /**
       * 休憩時間算出
       */
      getBreakHours(row, key) {
        row['breakHours' + key] = (utils.getHours(row['start' + key], row['end' + key])) - (row['workingHours' + key] || 0)

        this.isChanged(row, 'workingHours' + key)

        this.reloadAttendance++
      },

      /**
       * 勤務コピー
       * @param row 対象データ
       * @param key 対象曜日キー
       */
      copy(row, key) {
        if (this.type == '契約変更') {
          this.copied = {
            attendance: row['attendance' + key + 'Changed'],
            start: row['start' + key + 'Changed'],
            end: row['end' + key + 'Changed'],
            workingHours: row['workingHours' + key + 'Changed'],
            breakHours: row['breakHours' + key + 'Changed']
          }
        } else {
          this.copied = {
            attendance: row['attendance' + key],
            start: row['start' + key],
            end: row['end' + key],
            workingHours: row['workingHours' + key],
            breakHours: row['breakHours' + key]
          }
        }
      },

      /**
       * ペースト
       * @param row 対象データ
       * @param key 対象曜日キー
       */
      paste(row, key) {
        if (this.type == '契約変更') {
          row['attendance' + key + 'Changed'] = this.copied.attendance
          row['start' + key + 'Changed'] = this.copied.start
          row['end' + key + 'Changed'] = this.copied.end
          row['workingHours' + key + 'Changed'] = this.copied.workingHours
          row['breakHours' + key + 'Changed'] = this.copied.breakHours

          this.attendanceChanged(row, key)

          const key2 = key + 'Changed'
          this.isChanged(row, 'workingHours' + key2)
          this.isChanged(row, 'start' + key2)
          this.isChanged(row, 'end' + key2)

        } else {
          row['attendance' + key] = this.copied.attendance
          row['start' + key] = this.copied.start
          row['end' + key] = this.copied.end
          row['workingHours' + key] = this.copied.workingHours
          row['breakHours' + key] = this.copied.breakHours
        }

        this.reloadAttendance++
      },


      /**
      * 交通費区分変更イベント
      * @param {*} row 対象
      * @param type 区分
      * @param fee 交通費
      */
      changeTrans(row, type, fee) {
        if (row[type] == 0) {
          row[fee] = '0'
        } else if (row[type]) {
          if (row[fee] == '0') {
            row[fee] = ''
          }
        }

        this.isChanged(row, type)
        this.isChanged(row, fee)
        this.reload++
      },

      /**
       * タイトルをセット
       */
      setTitle() {
        if (this.type != '新規入社') {
          this.$emit('get-title2', this.requestPost)
        }
      },

      /**
       * 清掃員リスト取得
       */
      async getEmploymentNameList() {
        this.employmentNameList = []
        // 新規入社の場合は取得不要
        if (this.type == '新規入社') {
          return
        }

        const list = await backend.searchData('akbsTable/getInstructEmploymentStaff', { type: this.type})
        if (list && list.data.data && list.data.data.length) {
          this.staffListType = ''
          if (this.type == '再入社') {
            this.staffListType = '退職者'
          }
          this.employmentNameList = list.data.data
        }
      },

      /**
       * 清掃員名選択
       */
      async staffSelected(e) {
        if (this.type == '再入社') {
          this.requestPost.beforeStaffCd = e.staffDailyCleaning
          this.requestPost.employmentStaffNumber = ''
        } else {
          this.requestPost.employmentStaffNumber = e.staffDailyCleaning
        }
        
        this.requestPost.employmentMobile = e.numberMobilePhoneStaff
        this.requestPost.birthday = e.birthday
        this.requestPost.age = e.age

        if (['その他変更', '再入社'].includes(this.type)) {
          this.requestPost.staffName = this.requestPost.employmentName
          this.requestPost.employmentKana = utils.zenkaku(e.nameKanaStaff || '')
          this.requestPost.employmentBirthDay = e.birthday
          this.requestPost.employmentSex = [e.sex]
          this.requestPost.employmentAddress1 = e.address1Staff
          this.requestPost.employmentAddress2 = e.address2Staff
          this.requestPost.employmentPostCode = e.zipStaff
          this.requestPost.employmentTel = e.numberPhoneStaff
          this.requestPost.employmentMobile = e.numberMobilePhoneStaff

          // 前の情報を保持
          this.requestPost.before = {}
          for (let i = 0; i < this.otherChangeItems.length; i++) {
            const row = this.otherChangeItems[i]
            this.requestPost.before[row.key] = this.requestPost[row.key]

            for (let j = 0; j < row.keys.length; j++) {
              const key = row.keys[j]
              this.requestPost.before[key] = this.requestPost[key]
            }
          }

          // 緊急連絡先
          const info = await backend.searchData('akbsTable/getStaffEmergency', { staffCd: e.staffDailyCleaning})
          if (info.data) {
            this.requestPost.emergency = info.data.emergency || [{}]
            this.requestPost.before.emergency = utils.clone(this.requestPost.emergency)
          }

          // 黄色のままになるところのみ変更フラグをOFF
          this.requestPost.employmentPostCodeIsChanged = false
          this.requestPost.employmentTelIsChanged = false
          this.requestPost.employmentMobileIsChanged = false
          this.requestPost.emergency.forEach(em => {
            em.postCodeIsChanged = false
            em.phoneNumberIsChanged = false
          })

          this.reload++
        }

        await this.getEmploymentBuildingList(e)
        this.setTitle()
        this.reload++
      },

      /**
       * 清掃員名変更
       */
      async staffChanged() {
        if (!this.requestPost.employmentName) {
          this.requestPost.employmentStaffNumber = ''
          this.requestPost.employmentMobile = ''
          this.requestPost.employmentUserId = ''
          this.requestPost.birthday = ''
          this.requestPost.age = ''
        }
        this.setTitle()
        this.reload++
      },

      /**
       * 物件リスト取得
       * @param {*} tar 選択した清掃員の情報
       */
      async getEmploymentBuildingList(tar) {
        // 種別が契約変更、もしくは退職
        const type = this.requestPost.employmentClass[0]
        if (type && (['契約変更', '退職']).includes(type) && this.requestPost.employmentStaffNumber) {
          this.loading = true

          const param = {
            staff: this.requestPost.employmentName,
            staffDailyCleaning: this.requestPost.employmentStaffNumber,
            type
          }

          // 清掃員選択した場合、その選択値をパラメータにする（念のため）
          if (tar && tar.nameStaff) {
            param.staff = tar.nameStaff
            param.staffDailyCleaning = tar.staffDailyCleaning
          }

          const list = await backend.searchData('akbsTable/getSiteData', param)

          // 現在、担当している物件がある場合
          if (list.data) {
            // 担当契約内容詳細
            if (tar) {
              // 変更箇所リセット
              this.requestPost.changeData = {}
              // 契約情報
              this.requestPost.contractList = this.getContractList(list.data.contract)
              // 得意先情報
              this.requestPost.clientLists = this.getClientList(list.data.contract)

              // 契約変更の場合
              if (type == '契約変更') {
                if (list.data.siteDetail && list.data.siteDetail.length) {
                  for (let i = 0; i < list.data.siteDetail.length; i++) {
                    const siteCode = list.data.siteDetail[i].siteCode
                    const detail = list.data.siteDetail[i].detail

                    for (let j = 0; j < this.requestPost.contractList.length; j++) {
                      const row = this.requestPost.contractList[j]

                      if (row.cdSite == siteCode) {
                        if (detail.wage) {
                          const siteWage = detail.wage.find((w) => {
                            return w.strRes2
                          })

                          if (siteWage) {
                            row.siteWage = siteWage.strRes3
                          }
                        }
                      }
                    }
                  }
                }

                // 1件しか契約がない場合は、チェックをつける
                if (this.requestPost.contractList && this.requestPost.contractList.length == 1) {
                  this.requestPost.contractList[0].isChecked = true
                  this.requestPost.clientLists[0].isChecked = true
                }
              }

            }
            this.loading = false
            return
          } else {
            this.requestPost.contractList = []
            this.requestPost.changeData = {}
          }
        }
        this.loading = false
      },

      /**
       * 物件リスト全取得
       */
      async getAllEmploymentBuildingList() {
        const list = await backend.searchData('akbsTable/getSiteList', null)

        const daikin = [{ nameSite: '代勤専門', cdSite: '000000000', clientCode: '' }]

        if (list && list.data.data && list.data.data.length) {
          this.employmentBuildingList = daikin.concat(list.data.data)
        } else {
          this.employmentBuildingList = []
        }
      },

      /**
       * 種別変更
       */
      async changeEmploymentClass() {
        // 再入社に変更、もしくは、再入社から違うものに変更
        if (this.type == '再入社' || (this.type != '再入社' && this.staffListType == '退職者')) {
          this.getEmploymentNameList()
        }
        this.setTitle()

        // メイン期限設定
        this.setLimitDate()
      },

      /**
       * 期限設定
       */
      setLimitDate() {
        if (this.type == '退職' && this.requestPost.employmentRetirementDate) {
          // 給料は翌月に生産されるため、退職日の翌月20日に設定
          this.requestPost.limitDate = moment(this.requestPost.employmentRetirementDate).add(1, 'months').format('YYYY-MM-20')
          // 期限日が1か月後なら長期タスク
          this.requestPost.kubunLimit = utils.getKubunLimit(this.requestPost.limitDate)

        // 新規
        } else if (this.type == '新規入社' || this.type == '再入社') {
          if (this.requestPost.employmentHireDate > this.requestPost.startDateWork) {
            this.requestPost.startDateWork = ''
          }
          this.requestPost.kubunLimit = 2
        }
        this.reload++
      },

      /**
       * 清掃員の新規入社
       */
      newEnterForCD() {
        // 選択させる
        this.$emit('newEnterForCD')
      },

      /**
       * 物件選択モーダルopen
       */
      openSiteModal() {
        this.siteModal = true
      },

      /**
       * 物件選択モーダルclose
       */
      async siteSelected(target) {
        this.requestPost.employmentSiteCode = target.cdSite
        this.requestPost.employmentBuildingName = target.nameSite
        this.requestPost.employmentSiteAddress = target.address
        // 選択した物件名を別で保存（チェックのため）
        this.requestPost.targetSite = target.nameSite

        // 得意先情報
        if (target.cdSite == '000000000') {
          this.requestPost.clientLists = []
        } else {
          this.requestPost.clientLists = [
            { clientCode: target.clientCode, clientName: (target.nameCustomer || '') + ' ' + (target.nameCustomer2 || '').trim(), clientFax: target.fax }
          ]
        }

        this.getArea()

        // 詳細を取得
        this.getDetilSiteInfo(true)

        // タイトル編集
        this.setTitle()

        this.siteModal = false
      },

      /**
       * 物件の詳細情報を取得
       * @param isChangeContract 倹約コード変更フラグ
       */
      async getDetilSiteInfo(isChangeContract) {
        this.loading = true

        // 契約変更あり
        if (isChangeContract) {
          this.requestPost.contractCode = null
        }

        this.requestPost.siteWage = []
        this.requestPost.siteShort = {}
        this.requestPost.contract = []

        if (this.requestPost.employmentSiteCode && this.requestPost.employmentSiteCode != '000000000') {
          const res = await backend.searchData('akbs/getSiteWage', { siteCode: this.requestPost.employmentSiteCode, onlyWage: false })

          // 時給単価
          if (res.data.data && res.data.data.wage) {
            for (let i = 0; i < res.data.data.wage.length; i++) {
              const r = res.data.data.wage[i]
              this.requestPost.siteWage.push({ cdContract: r.strRes2, wage: r.strRes3 })
            }
          }

          // 足りない時間（物件単位）
          if (res.data.data && res.data.data.short && res.data.data.short.length) {
            // 1物件1行のみ
            const s = res.data.data.short[0]
            this.requestPost.siteShort = { mon: Number(s.mon), tue: Number(s.tue), wed: Number(s.wed), thu: Number(s.thu), fri: Number(s.fri), sat: Number(s.sat), sun: Number(s.sun), total: Number(s.total), siteName: s.nameSite, date: moment().format('YYYY/MM/DD HH:mm') }
            Object.keys(this.requestPost.siteShort).forEach((s) => {
              // 過不足時間の色をセット
              this.setHoursColor(s, this.requestPost.siteShort[s], this.requestPost.siteShort)
            })
          }

          // 契約内容
          if (res.data.data && res.data.data.contract && res.data.data.contract.length) {
            this.requestPost.contract = res.data.data.contract
            this.requestPost.contract.forEach((c) => {
              c.date = moment().format('YYYY/MM/DD HH:mm')

              // 過不足時間の色をセット
              Object.keys(c).forEach((s) => {
                if (s.includes('2')) {
                  this.setHoursColor(s, Number(c[s]), c)
                }
              })
            })
            // 契約が1件しかない場合はその契約コードをセットする
            if (this.requestPost.contract.length == 1) {
              this.requestPost.contractCode = this.requestPost.contract[0].cdContract
              if (isChangeContract) {
                this.changeContract()
              }
            }
          }
        } else if (this.requestPost.employmentSiteCode == '000000000') {
          this.requestPost.contractCode = '00'
          this.requestPost.cdContentsWork = '50'
          this.requestPost.cdKubunHoliday = 0
          this.requestPost.hasCarryingoutGarbage = 0
          this.requestPost.hasExportingCompanysHoliday = 0
        }
        this.loading = false
        this.reload++
      },

      /**
       * 過不足時間の色設定
       * @param key
       * @param value
       */
      setHoursColor(key, value, tar) {
        if (value < 0) {
          tar[key + 'Color'] = 'font-bold text-red-700'
        } else if (value > 0) {
          tar[key + 'Color'] = 'font-bold text-blue-700'
        }
      },

      /**
       * 契約コード変更
       */
      changeContract() {
        // 契約コードあり
        if (this.requestPost.contractCode) {
          if (this.requestPost.contract && this.requestPost.contract.length) {
            const res = this.requestPost.contract.find((c) => {
              return c.cdContract == this.requestPost.contractCode
            })

            this.requestPost.appliedWork.forEach(row => {

              // 作業内容
              row.cdContentsWork = res.cdContentsWork

              // 祝日区分
              row.cdKubunHoliday = res.holiday

              // ゴミ搬出
              row.hasCarryingoutGarbage = res.garbage

              // 全社祝日勤務
              row.hasExportingCompanysHoliday = res.companyHoliday
            })
          }
        }
        this.reload++
      },

      /**
       * 物件変更イベント
       */
      siteChanged() {
        if (!this.requestPost.employmentBuildingName) {
          this.requestPost.employmentSiteCode = ''
          this.requestPost.employmentBuildingName = ''
          this.requestPost.targetSite = ''
          this.requestPost.clientLists = []
          this.requestPost.employmentSiteAddress = ''
          this.requestPost.area = ''
          this.requestPost.contractCode = null
          this.requestPost.siteWage = ''
          this.requestPost.siteShort = {}
          this.requestPost.contract = []
          this.requestPost.cdContentsWork = null
          this.requestPost.cdKubunHoliday = null
          this.requestPost.hasCarryingoutGarbage = null
          this.requestPost.hasExportingCompanysHoliday = null
        }
        this.setTitle()
      },

      /**
       * 住所からエリアを取得
       */
      getArea() {
        let ad = this.requestPost.employmentSiteAddress

        // 代勤の場合は清掃員の住所
        if (this.requestPost.employmentSiteCode == '000000000') {
          ad = this.requestPost.employmentAddress1
        }

        if (ad) {
          for (let i = 0; i < this.areaSelections.length; i++) {
            const a = this.areaSelections[i]
            if (ad.includes(a.replace('エリア', ''))) {
              this.requestPost.area = a
              return
            }
          }
        }

        this.requestPost.area = ''
      },

      /**
       * 「得意先の選択」モーダルOPEN
       */
      openClientModal(i) {
        this.clientModal = true
        this.modalData = i
      },

      /**
       * 「得意先の選択」モーダルでの得意先選択イベント
       * @param {*} i インデックス
       * @param {*} target 選択した内容
       */
      modalClientSelected(i, target) {
        this.clientModal = false
        this.clientSelected(this.requestPost.clientLists[i], target)
      },

      /**
       * 得意先選択イベント
       * @param {*} row 対象行
       * @param {*} selectedClient 選択した内容
       */
      clientSelected(row, selectedClient) {
        // 選択したお客様情報を表示
        row.clientName = selectedClient.clientName
        if (selectedClient.clientDepartmentName) {
          row.clientName += ' ' + selectedClient.clientDepartmentName
        }

        row.clientCode = selectedClient.clientCode

        // FAX番号
        row.clientFax = selectedClient.clientFax

        this.reload++
      },

      /**
       * 得意先変更イベント
       * @param row 対象行
       */
      clientNameChanged(row) {
        if (!row.clientName) {
          row.clientCode = ''
          row.clientFax = ''
        }
        this.reload++
      },

      /**
       * 得意先へ連絡モーダルopen
       * @param isMail メールか否か
       * @param {*} row 対象得意先
       */
      async opentMessageForClient(isMail, row) {
        this.client = {}
        this.isMail = isMail
        // 種別確認
        if (this.requestPost.employmentClass && this.type) {
          // 対象日確認
          if (!this.requireValidateStr('employmentHireDate', '入社日').result) {
            await dialogs.showErrorDialog('入社日未入力', this.requireValidateStr('employmentHireDate', '入社日').message)
            return
          }
          if (!this.requireValidateStr('employmentRetirementDate', '退職日').result) {
            await dialogs.showErrorDialog('退社日未入力', this.requireValidateStr('employmentRetirementDate', '退職日').message)
            return
          }
        } else {
          await dialogs.showErrorDialog('種別未選択', '種別を選択して下さい。')
          return
        }

        this.messageForClientInfo = utils.clone(row)
        if (!this.messageForClientInfo.siteName && this.requestPost.employmentBuildingName) {
          this.messageForClientInfo.siteName = this.requestPost.employmentBuildingName

          // 作業内容
          if (this.requestPost.appliedWork[0] && this.requestPost.appliedWork[0].cdContentsWork) {
            this.messageForClientInfo.nameContentsWork = this.getNameContentsWork(this.requestPost.appliedWork[0].cdContentsWork)
          }
        }

        // 得意先情報を取得
        if (row.clientCode) {
          if (this.clientLists) {
            const client = this.clientLists.find((c) => {
              return c.clientCode == row.clientCode
            })
            if (client) {
              let res = false
              const name = ((client.clientName || '') + ' ' + (client.clientDepartmentName || '')).trim()
              // コードから取得した名前と画面上の名前が正しいか
              if (name == row.clientName.trim()) {
                res = true
                this.client = client
              // 支店名がない場合、もう一度確認
              } else if (!client.clientDepartmentName) {
                if (client.clientName == row.clientName.trim()) {
                  res = true
                  this.client = client
                }
              }
              // 得意先名と得意先コードが合っていない
              if (!res) {
                await dialogs.showErrorDialog('得意先名を再度選択クリックしてください。', '得意先情報の取得が不十分です。\r\n再度、得意先名のドロップダウンを選択クリックしてください。')
                return
              }
            }
          } else {
            alert('エラーが発生しました。')
            return
          }
        } else {
          console.log('得意先コード無し')
          await dialogs.showErrorDialog('得意先名を再度選択クリックしてください。', '得意先情報の取得が不十分です。\r\n再度、得意先名のドロップダウンを選択クリックしてください。')
          return
        }
        this.messageForClient = true
      },

      /**
       * 契約リスト 変換
       */
      getContractList(list) {
        list.forEach(row => {
          const keys = Object.keys(row)

          keys.forEach(key => {
            // 勤務形態区分 選択コンポーネント用に成形
            if ( key.includes('attendance')) {
              const week = key.replace('attendance', '')

              if (row['attendance' + week] && row['attendance' + week].length) {
                const att = []
                this.attendanceList.forEach(a => {
                  if (row['attendance' + week].includes(a.id)) {
                    att.push(a)
                  }
                })
                row['attendance' + week] = att
                row['attendance' + week + 'Changed'] = att
              } else {
                // 勤務形態がない場合、実働時間で再確認する（念のため）
                if (row['workingHours' + week] && Number(row['workingHours' + week]) > 0) {
                  // 実働があれば、毎週をセット
                  row['attendance' + week] = this.attendanceList[0]
                  row['attendance' + week + 'Changed'] = this.attendanceList[0]
                }
              }

              if (row['attendance' + week] && row['attendance' + week].length) {
                // 休憩時間を算出
                this.getBreakHours(row, week)
                row['breakHours' + week + 'Changed'] = row['breakHours' + week]
              }

            // 変更用にコピー
            } else if (
              ![
                'sequenceNumber', 'staffDailyCleaning', 'startDateWork', 'endDateWork', 'cdSite', 'cdContract', 'nameSite', 'cdContentsWorkContract'
                , 'clientCodeSi', 'nameCustomerSi', 'nameCustomer2Si', 'clientName', 'fax'
              ].includes(key)
            ) {
              row[key +  'Changed'] = row[key]
            }
          })
        })
        // console.log(list)

        return list
      },

      /**
       * 得意先配列生成
       */
      getClientList(list) {
        if (list && list.length) {
          const res = list.map((row) => {
            return {
                clientCode: row.clientCodeSi,
                clientName: (row.nameCustomerSi || '') + ' ' + (row.nameCustomer2Si || '').trim(),
                clientFax: row.fax,
                cdSite: row.cdSite,
                cdContract: row.cdContract,
                siteName: row.nameSite,
                nameContentsWork: row.nameContentsWork,
                sequenceNumber: row.sequenceNumber
              }
          })
          return res

        } else {
          return []
        }
      },

      /**
       * 契約変更にて勤務形態を変更
       * @param row 対象行
       * @param week 対象曜日プロパティ
       */
      attendanceChanged(row, week) {
        const before = (row['attendance' + week] || []).map(e => e.id)
        const after = (row['attendance' + week + 'Changed'] || []).map(e => e.id)
        const key = 'attendance' + week + 'IsChanged'

        // 両方なし
        if ((!before.length) && (!after.length)) {
          row[key] = false

        } else {
          // 要素数が違う
          if (before.length != after.length) {
            row[key] = true
          } else {
            const sorted1 = before.sort((a, b) => a - b)
            const sorted2 = after.sort((a, b) => a - b)

            row[key] = !(sorted1.every((v, i) => v === sorted2[i]))
          }
        }
        this.getChangePoint()
        this.reloadAttendance++
      },

      /**
       * 前の値と変更があるか
       */
      async isChanged(row, prop) {
        if (['契約変更'].includes(this.type) && prop.includes('Changed')) {
          let res = true
          const before = row[prop.replace('Changed', '')]
          const after = row[prop]

          if (!before && !after) {
            res = false
          } else if (before == after) {
            res = false
          }
          row[prop.replace('Changed', 'IsChanged')] = res
          this.getChangePoint()

          if (prop.includes('basicWage')) {
            // 賃金の上限下限を確認
            await this.limitHourlyWageInput(row)
          }
          this.reload++
        }
      },

      /**
       * その他変更
       */
      async isOtherChange(row, i, prop, prop2) {
        if (['その他変更', '再入社'].includes(this.type)) {
          let before = null
          let after = null

          if (i >= 0) {
            if (this.requestPost.before[prop] && this.requestPost.before[prop][i]) {
              before = this.requestPost.before[prop][i][prop2]
            }
            after = row[prop2]
          } else {
            before = this.requestPost.before[prop]
            after = row[prop]
          }

          let res = true

          if (!before && !after) {
            res = false
          } else if (before == after) {
            res = false
          }

          if (i >= 0) {
            row[prop2 + 'IsChanged'] = res
          } else {
            row[prop + 'IsChanged'] = res
          }
          this.reload++
        }
      },

      /**
       * 変更箇所一覧を生成
       */
      getChangePoint() {
        let list = []
        for (let i = 0; i < this.requestPost.contractList.length; i++) {
          const row = this.requestPost.contractList[i]
          if (!row.isChecked) continue

          const ky = Object.keys(row)
          for (let j = 0; j < ky.length; j++) {
            const k = ky[j]
            // 変更ある場合
            if (row[k + 'IsChanged']) {
              const names = this.getPropName(k, i, row.nameSite)
              let flg = false
              for (let idx = 0; idx < list.length; idx++) {
                const l = list[idx]
                if (l.site == names.site) {
                  flg = true
                  if (!l.list) {
                    l.list = []
                  }
                  l.list.push(names.name)
                }
              }
              if (!flg) {
                list.push({ site: names.site, list: [names.name] })
              }
            }
          }
        }
        this.requestPost.changeData = list
      },

      /**
       * プロパティ名を取得
       */
      getPropName(key, i, site) {
        const list = [
          { key: 'Sunday', name: '日曜' },
          { key: 'Monday', name: '月曜' },
          { key: 'Tuesday', name: '火曜' },
          { key: 'Wednesday', name: '水曜' },
          { key: 'Thursday', name: '木曜' },
          { key: 'Friday', name: '金曜' },
          { key: 'Saturday', name: '土曜' },
          { key: 'attendance', name: ' 出勤形態' },
          { key: 'workingHours', name: ' 実働時間' },
          { key: 'start', name: ' 開始時間' },
          { key: 'end', name: ' 終了時間' },

          { key: 'Wage', name: '賃金' },

          ...this.setHoliday,
          ...this.setKubunTrans,
          ...this.setFareTrans
        ]

        // 項目名を取得
        let name = ''
        for (let i = 0; i < list.length; i++) {
          const e = list[i]
          if (key.includes(e.key)) {
            if (e.key == 'end' && key.includes('attendance')) {
              continue
            }
            name += e.name
          }
        }
        return { site: 'No.' + (i + 1) + ' ' + site, name }
      },

      /**
       * 契約変更の種別
       */
      clickModifyType(val, changeOnlyPrice) {
        if (this.referenceMode) {
          return
        }
        this.requestPost.modifyType = val
        this.requestPost.changeOnlyPrice = changeOnlyPrice
        this.setTitle()
        this.reload++
      },

      /**
       * その他変更の変更対象項目
       */
      clickOtherChange(item) {
        if (this.referenceMode2) {
          return
        }
        // 再選択された場合
        if (this.requestPost.otherChangeItemsKey.includes(item.key)) {
          this.requestPost.otherChangeItemsKey = this.requestPost.otherChangeItemsKey.filter((o) => {
            return o != item.key && !item.keys.includes(o)
          })
          this.requestPost.otherChangeItemsName = this.requestPost.otherChangeItemsName.filter((o) => {
            return !item.names.includes(o)
          })

        // 追加選択された場合
        } else {
          this.requestPost.otherChangeItemsKey.push(item.key)
          this.requestPost.otherChangeItemsKey = this.requestPost.otherChangeItemsKey.concat(item.keys)
          this.requestPost.otherChangeItemsName = this.requestPost.otherChangeItemsName.concat(item.names)
        }
      },

      /**
       * 作業終了チェク
       */
      checkWorkEnd(row) {
        this.getChangePoint()
        for (let i = 0; i < this.requestPost.clientLists.length; i++) {
          const c = this.requestPost.clientLists[i]
          if (row.sequenceNumber == c.sequenceNumber) {
            c.isChecked = row.isChecked
            this.reload++
            return
          }
        }
      },

      /**
       * 清掃員詳細画面
       */
    }
  }
</script>

<style scoped>
  .five-selection >>> button[type=button] {
    width: 19.8% !important;
  }

  .yellow >>> input,
  select.yellow,
  .yellow >>> input[type=text] {
    background-color: #FFF59D !important;
    font-weight: bold !important;
  }

  .yellow >>> input[type=text]:disabled {
    background-color: #FFF59D !important;
    font-weight: bold !important;
  }

  .yellow-input {
    background-color: #FFF59D !important;
    font-weight: bold;
  }

  .multi >>> .multiselect__tags {
    padding-right: 4px !important; /* デフォルトは40pxくらいある */
  }

  .yellow-multi >>> .multiselect__tags,
  .yellow-multi >>> .multiselect--disabled .multiselect__tags {
    background-color: #FFF59D !important;
  }
</style>